/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

import * as Types from '__generated__/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetVoyagesQueryVariables = Types.Exact<{
  search: Types.VoyageSearchObject;
  pagination: Types.Pagination;
  includeCargos: Types.Scalars['Boolean']['input'];
}>;


export type GetVoyagesQuery = {
  __typename?: 'Query',
  voyages: {
    __typename?: 'VoyagePage',
    totalElements: number,
    content: Array<{
      __typename?: 'Voyage',
      id: number,
      voyageNumber: string,
      externalVoyageNumber?: string | null,
      allSuppliersConfigured?: boolean | null,
      start?: number | null,
      end?: number | null,
      invoiceableWeek?: number | null,
      created?: number | null,
      isBallast: boolean,
      actualWeightFilledIn: boolean,
      actualTimeFilledIn: boolean,
      actualStart?: number | null,
      actualEnd?: number | null,
      ship: {
        __typename?: 'Ship',
        id: number,
        bargeType?: Types.BargeType | null,
        name: string,
        operator?: {
          __typename?: 'Relation',
          id: number,
          name: string,
          isApplicationRelation?: boolean | null
        } | null,
        fleets: Array<{
          __typename?: 'Fleet',
          id: number,
          description: string
        }>
      },
      lastStatusChange?: {
        __typename?: 'StatusChange',
        id: number,
        actualTime?: number | null,
        actualTimeOriginal?: number | null,
        actualTimeOverride?: number | null,
        estimateTime?: number | null,
        comment?: string | null,
        skipperComment?: string | null,
        timestamp?: number | null,
        appliedBy?: string | null,
        deletable: boolean,
        communicatedToCustomer?: number | null,
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          type: Types.StatusType,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }>,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null
        },
        supplier?: {
          __typename?: 'Relation',
          id: number,
          name: string
        } | null,
        origin?: {
          __typename?: 'StatusChange',
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }
        } | null
      } | null,
      statusChanges: Array<{
        __typename?: 'StatusChange',
        id: number,
        actualTime?: number | null,
        actualTimeOriginal?: number | null,
        actualTimeOverride?: number | null,
        estimateTime?: number | null,
        comment?: string | null,
        skipperComment?: string | null,
        timestamp?: number | null,
        appliedBy?: string | null,
        deletable: boolean,
        communicatedToCustomer?: number | null,
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          type: Types.StatusType,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }>,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null
        },
        supplier?: {
          __typename?: 'Relation',
          id: number,
          name: string
        } | null,
        origin?: {
          __typename?: 'StatusChange',
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }
        } | null
      }>,
      purchaseCharters?: Array<{
        __typename?: 'PurchaseCharter',
        id: number,
        type: Types.CharterType,
        subtype: Types.CharterSubtype,
        customerReference?: string | null,
        charterNumber: string,
        creditor: {
          __typename?: 'Relation',
          id: number,
          name: string,
          customerNumber?: string | null
        }
      }> | null,
      from?: {
        __typename?: 'Location',
        id: number,
        description: string,
        type: Types.LocationType,
        locationGroups: Array<{
          __typename?: 'Location',
          type: Types.LocationType,
          description: string
        }>
      } | null,
      to?: {
        __typename?: 'Location',
        id: number,
        description: string,
        locationGroups: Array<{
          __typename?: 'Location',
          type: Types.LocationType,
          description: string
        }>
      } | null,
      calls: Array<{
        __typename?: 'Call',
        id: number,
        pta?: number | null,
        ptd?: number | null,
        eta?: number | null,
        systemEta?: number | null,
        etd?: number | null,
        ata?: number | null,
        systemAta?: number | null,
        atd?: number | null,
        systemAtd?: number | null,
        actualStatusCode?: number | null,
        simulatedTimestamp: boolean,
        location: {
          __typename?: 'Location',
          id: number,
          code?: string | null,
          type: Types.LocationType,
          displayCode?: string | null,
          description: string,
          locationGroups: Array<{
            __typename?: 'Location',
            type: Types.LocationType,
            description: string
          }>
        },
        linkedChildCalls: Array<{
          __typename?: 'Call',
          id: number,
          weight?: number | null,
          voyage: {
            __typename?: 'Voyage',
            voyageNumber: string,
            ship: {
              __typename?: 'Ship',
              id: number,
              name: string
            }
          }
        }>,
        voyage: {
          __typename?: 'Voyage',
          ship: {
            __typename?: 'Ship',
            id: number,
            bargeType?: Types.BargeType | null
          }
        }
      }>,
      creditor?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      scopeIn?: {
        __typename?: 'Scope',
        desired?: number | null,
        planned?: number | null,
        expected?: number | null,
        systemExpected?: number | null,
        actual?: number | null,
        systemActual?: number | null,
        expectedLocation?: {
          __typename?: 'Location',
          id: number,
          description: string
        } | null,
        plannedLocation?: {
          __typename?: 'Location',
          id: number,
          description: string
        } | null,
        actualLocation?: {
          __typename?: 'Location',
          id: number,
          description: string
        } | null
      } | null,
      scopeOut?: {
        __typename?: 'Scope',
        desired?: number | null,
        planned?: number | null,
        expected?: number | null,
        systemExpected?: number | null,
        actual?: number | null,
        systemActual?: number | null,
        expectedLocation?: {
          __typename?: 'Location',
          id: number,
          description: string
        } | null,
        plannedLocation?: {
          __typename?: 'Location',
          id: number,
          description: string
        } | null,
        actualLocation?: {
          __typename?: 'Location',
          id: number,
          description: string
        } | null
      } | null,
      cargoCharters?: Array<{
        __typename?: 'SalesCharter',
        id: number,
        charterNumber: string,
        type: Types.CharterType,
        debtor: {
          __typename?: 'Relation',
          id: number,
          name: string
        }
      } | null> | null,
      sailingReport?: {
        __typename?: 'SailingReport',
        id: number
      } | null,
      cargos?: Array<{
        __typename?: 'Cargo',
        id: number,
        productDetails?: string | null,
        cargoNumber?: string | null,
        containerNumber?: string | null,
        loadingReference?: string | null,
        dischargingReference?: string | null,
        isWeightPrimary: boolean,
        isVolumePrimary: boolean,
        waterLevelOptimised: boolean,
        volume?: number | null,
        weight?: number | null,
        product?: {
          __typename?: 'Product',
          id: number,
          name: string
        } | null,
        supplier?: {
          __typename?: 'Relation',
          id: number,
          name: string
        } | null
      }>
    }>
  }
};

export type GetVoyageQueryVariables = Types.Exact<{
  id: Types.Scalars['Long']['input'];
}>;


export type GetVoyageQuery = {
  __typename?: 'Query',
  voyage?: {
    __typename?: 'Voyage',
    id: number,
    voyageNumber: string,
    inactivityType?: Types.InactivityType | null,
    isBallast: boolean,
    start?: number | null,
    end?: number | null,
    lastShippedProductsFreeText: Array<string>,
    sailingReport?: {
      __typename?: 'SailingReport',
      id: number
    } | null,
    cargos: Array<{
      __typename?: 'Cargo',
      id: number,
      cargoNumber?: string | null,
      containerNumber?: string | null,
      charter?: {
        __typename?: 'SalesCharter',
        id: number,
        charterNumber: string,
        creditor: {
          __typename?: 'Relation',
          id: number,
          name: string,
          applicationRelation?: boolean | null
        },
        debtor: {
          __typename?: 'Relation',
          id: number,
          name: string,
          applicationRelation?: boolean | null
        }
      } | null,
      product?: {
        __typename?: 'Product',
        name: string
      } | null
    }>,
    calls: Array<{
      __typename?: 'Call',
      id: number,
      expectedLoadingAmount?: number | null,
      expectedDischargingAmount?: number | null,
      expectedLoadingTeu?: number | null,
      expectedDischargingTeu?: number | null,
      nrLoadingCargos: number,
      nrDischargingCargos: number,
      callLoadingTeu?: number | null,
      callDischargingTeu?: number | null,
      simulatedTimestamp: boolean,
      pta?: number | null,
      ptd?: number | null,
      ata?: number | null,
      atd?: number | null,
      eta?: number | null,
      etd?: number | null,
      loadedWeight?: number | null,
      dischargedWeight?: number | null,
      etso?: number | null,
      eteo?: number | null,
      atso?: number | null,
      ateo?: number | null,
      etfm?: number | null,
      etlm?: number | null,
      atfm?: number | null,
      atlm?: number | null,
      atn?: number | null,
      dtn?: number | null,
      systemAta?: number | null,
      systemAtd?: number | null,
      systemEta?: number | null,
      systemEtd?: number | null,
      location: {
        __typename?: 'Location',
        encodedPolyline?: string | null,
        type: Types.LocationType,
        id: number,
        description: string,
        position?: {
          __typename?: 'Position',
          longitude: number,
          latitude: number
        } | null,
        locationGroups: Array<{
          __typename?: 'Location',
          code?: string | null,
          id: number,
          description: string,
          type: Types.LocationType
        }>
      },
      cargos: Array<{
        __typename?: 'CargoAction',
        start?: number | null,
        end?: number | null,
        displayAsWindow?: boolean | null,
        id: number,
        type: Types.CallType,
        timesheetNote?: string | null,
        simulatedTimestamp?: boolean | null,
        weight?: number | null,
        volume?: number | null,
        limitType?: Types.LimitType | null,
        limitValue?: number | null,
        notes?: string | null,
        reference?: string | null,
        shipToShip?: boolean | null,
        connectingVisitNotes?: string | null,
        location?: {
          __typename?: 'Location',
          displayCode?: string | null,
          code?: string | null,
          notes?: string | null,
          uabRegistration?: boolean | null,
          id: number,
          description: string,
          type: Types.LocationType,
          contacts?: Array<{
            __typename?: 'Contact',
            id: number,
            name?: string | null,
            telephone?: string | null
          }> | null,
          locationGroups: Array<{
            __typename?: 'Location',
            code?: string | null,
            id: number,
            description: string,
            type: Types.LocationType
          }>
        } | null,
        cargo: {
          __typename?: 'Cargo',
          id: number,
          cargoNumber?: string | null,
          containerNumber?: string | null,
          weight?: number | null,
          volume?: number | null,
          isWeightPrimary: boolean,
          isVolumePrimary: boolean,
          waterLevelOptimised: boolean,
          weightToleranceType?: Types.WeightToleranceType | null,
          weightOptionType?: Types.WeightOptionType | null,
          weightOptionPercentage?: number | null,
          declaredFinalWeight?: number | null,
          isHoseRentalRequired: boolean,
          isInhibitedProduct: boolean,
          isNitrogenBlanketingRequired: boolean,
          isNitrogenPurgingRequired: boolean,
          isTemperatureControlRequired: boolean,
          isCleaningRequired: boolean,
          loadingReference?: string | null,
          dischargingReference?: string | null,
          lastStatusChange?: {
            __typename?: 'StatusChange',
            id: number,
            actualTime?: number | null,
            actualTimeOriginal?: number | null,
            actualTimeOverride?: number | null,
            estimateTime?: number | null,
            comment?: string | null,
            skipperComment?: string | null,
            timestamp?: number | null,
            appliedBy?: string | null,
            deletable: boolean,
            communicatedToCustomer?: number | null,
            status: {
              __typename?: 'Status',
              id: number,
              statusOrder?: number | null,
              cargoActionType?: Types.CallType | null,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              description: string,
              type: Types.StatusType,
              color: string,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean,
                cargoActionType?: Types.CallType | null,
                color: string,
                statusOrder?: number | null,
                supplierRequired: boolean,
                skipperRequiredFillInSailingReport: boolean,
                skipperRequiredFillInWeightVolume: boolean,
                requireActualTime: Types.StatusActualTimeType,
                estimateType?: Types.StatusEstimateType | null,
                estimateRequirement: Types.StatusEstimateRequirement,
                shouldLoadOnTerminal: boolean,
                closedStatus: boolean,
                cancelledStatus: boolean,
                loadedStatus: boolean,
                dischargedStatus: boolean,
                finishedStatus: boolean,
                allowComment: boolean,
                allowSkipperComment: boolean,
                shouldUpdateJDE: boolean,
                isInProgress: boolean,
                voyageVisibleBySkipper: boolean,
                voyageVisibleByCreditor: boolean,
                voyageEditableBySkipper: boolean,
                voyageEditableByCreditor: boolean,
                callVisibleByLocationOwner: boolean,
                isRejectStatus: boolean,
                isAcceptStatus: boolean,
                notifySkippers: boolean,
                notifyShipManagers: boolean,
                notifyShipOwners: boolean,
                notifyOperators: boolean,
                notifyCustomers: boolean,
                notifyTerminals: boolean,
                isCustomerNominatingStatus: boolean,
                isSkipperNominatingStatus: boolean,
                includeInNominationExport: boolean,
                laytimeStartStatus: boolean,
                laytimeEndStatus: boolean,
                requireDocuments: boolean,
                showConfirmMessage: boolean,
                expiringStatus: boolean,
                isActionStatus: boolean,
                requireTanks: boolean,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean,
                  type?: Types.SendDocumentType | null,
                  target?: Types.DocumentTarget | null
                } | null,
                translations?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                confirmMessages?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                rules?: Array<{
                  __typename?: 'Rule',
                  id: number,
                  ifFitsStatusFlow: boolean,
                  ifNotAppliedBefore: boolean,
                  ruleType: {
                    __typename?: 'RuleType',
                    name: Types.StatusRule
                  },
                  targetStatus: {
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    supplierRequired: boolean,
                    description: string,
                    sendDocument?: {
                      __typename?: 'SendDocumentStatus',
                      enabled: boolean
                    } | null
                  }
                }> | null,
                successiveStatuses: Array<{
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  description: string,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean
                }>
              }>,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null
            },
            supplier?: {
              __typename?: 'Relation',
              id: number,
              name: string
            } | null,
            origin?: {
              __typename?: 'StatusChange',
              status: {
                __typename?: 'Status',
                id: number,
                description: string,
                type: Types.StatusType,
                cargoActionType?: Types.CallType | null,
                color: string,
                statusOrder?: number | null,
                supplierRequired: boolean,
                skipperRequiredFillInSailingReport: boolean,
                skipperRequiredFillInWeightVolume: boolean,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean,
                requireActualTime: Types.StatusActualTimeType,
                estimateType?: Types.StatusEstimateType | null,
                estimateRequirement: Types.StatusEstimateRequirement,
                shouldLoadOnTerminal: boolean,
                closedStatus: boolean,
                cancelledStatus: boolean,
                loadedStatus: boolean,
                dischargedStatus: boolean,
                finishedStatus: boolean,
                allowComment: boolean,
                allowSkipperComment: boolean,
                shouldUpdateJDE: boolean,
                isInProgress: boolean,
                voyageVisibleBySkipper: boolean,
                voyageVisibleByCreditor: boolean,
                voyageEditableBySkipper: boolean,
                voyageEditableByCreditor: boolean,
                callVisibleByLocationOwner: boolean,
                isRejectStatus: boolean,
                isAcceptStatus: boolean,
                notifySkippers: boolean,
                notifyShipManagers: boolean,
                notifyShipOwners: boolean,
                notifyOperators: boolean,
                notifyCustomers: boolean,
                notifyTerminals: boolean,
                isCustomerNominatingStatus: boolean,
                isSkipperNominatingStatus: boolean,
                includeInNominationExport: boolean,
                laytimeStartStatus: boolean,
                laytimeEndStatus: boolean,
                requireDocuments: boolean,
                showConfirmMessage: boolean,
                expiringStatus: boolean,
                isActionStatus: boolean,
                requireTanks: boolean,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean,
                  type?: Types.SendDocumentType | null,
                  target?: Types.DocumentTarget | null
                } | null,
                translations?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                confirmMessages?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                rules?: Array<{
                  __typename?: 'Rule',
                  id: number,
                  ifFitsStatusFlow: boolean,
                  ifNotAppliedBefore: boolean,
                  ruleType: {
                    __typename?: 'RuleType',
                    name: Types.StatusRule
                  },
                  targetStatus: {
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    supplierRequired: boolean,
                    description: string,
                    sendDocument?: {
                      __typename?: 'SendDocumentStatus',
                      enabled: boolean
                    } | null
                  }
                }> | null,
                successiveStatuses: Array<{
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  description: string,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean
                }>
              }
            } | null
          } | null,
          statusChanges: Array<{
            __typename?: 'StatusChange',
            id: number,
            actualTime?: number | null,
            actualTimeOriginal?: number | null,
            actualTimeOverride?: number | null,
            estimateTime?: number | null,
            comment?: string | null,
            skipperComment?: string | null,
            timestamp?: number | null,
            appliedBy?: string | null,
            deletable: boolean,
            communicatedToCustomer?: number | null,
            status: {
              __typename?: 'Status',
              id: number,
              statusOrder?: number | null,
              cargoActionType?: Types.CallType | null,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              description: string,
              type: Types.StatusType,
              color: string,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean,
                cargoActionType?: Types.CallType | null,
                color: string,
                statusOrder?: number | null,
                supplierRequired: boolean,
                skipperRequiredFillInSailingReport: boolean,
                skipperRequiredFillInWeightVolume: boolean,
                requireActualTime: Types.StatusActualTimeType,
                estimateType?: Types.StatusEstimateType | null,
                estimateRequirement: Types.StatusEstimateRequirement,
                shouldLoadOnTerminal: boolean,
                closedStatus: boolean,
                cancelledStatus: boolean,
                loadedStatus: boolean,
                dischargedStatus: boolean,
                finishedStatus: boolean,
                allowComment: boolean,
                allowSkipperComment: boolean,
                shouldUpdateJDE: boolean,
                isInProgress: boolean,
                voyageVisibleBySkipper: boolean,
                voyageVisibleByCreditor: boolean,
                voyageEditableBySkipper: boolean,
                voyageEditableByCreditor: boolean,
                callVisibleByLocationOwner: boolean,
                isRejectStatus: boolean,
                isAcceptStatus: boolean,
                notifySkippers: boolean,
                notifyShipManagers: boolean,
                notifyShipOwners: boolean,
                notifyOperators: boolean,
                notifyCustomers: boolean,
                notifyTerminals: boolean,
                isCustomerNominatingStatus: boolean,
                isSkipperNominatingStatus: boolean,
                includeInNominationExport: boolean,
                laytimeStartStatus: boolean,
                laytimeEndStatus: boolean,
                requireDocuments: boolean,
                showConfirmMessage: boolean,
                expiringStatus: boolean,
                isActionStatus: boolean,
                requireTanks: boolean,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean,
                  type?: Types.SendDocumentType | null,
                  target?: Types.DocumentTarget | null
                } | null,
                translations?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                confirmMessages?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                rules?: Array<{
                  __typename?: 'Rule',
                  id: number,
                  ifFitsStatusFlow: boolean,
                  ifNotAppliedBefore: boolean,
                  ruleType: {
                    __typename?: 'RuleType',
                    name: Types.StatusRule
                  },
                  targetStatus: {
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    supplierRequired: boolean,
                    description: string,
                    sendDocument?: {
                      __typename?: 'SendDocumentStatus',
                      enabled: boolean
                    } | null
                  }
                }> | null,
                successiveStatuses: Array<{
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  description: string,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean
                }>
              }>,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null
            },
            supplier?: {
              __typename?: 'Relation',
              id: number,
              name: string
            } | null,
            origin?: {
              __typename?: 'StatusChange',
              status: {
                __typename?: 'Status',
                id: number,
                description: string,
                type: Types.StatusType,
                cargoActionType?: Types.CallType | null,
                color: string,
                statusOrder?: number | null,
                supplierRequired: boolean,
                skipperRequiredFillInSailingReport: boolean,
                skipperRequiredFillInWeightVolume: boolean,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean,
                requireActualTime: Types.StatusActualTimeType,
                estimateType?: Types.StatusEstimateType | null,
                estimateRequirement: Types.StatusEstimateRequirement,
                shouldLoadOnTerminal: boolean,
                closedStatus: boolean,
                cancelledStatus: boolean,
                loadedStatus: boolean,
                dischargedStatus: boolean,
                finishedStatus: boolean,
                allowComment: boolean,
                allowSkipperComment: boolean,
                shouldUpdateJDE: boolean,
                isInProgress: boolean,
                voyageVisibleBySkipper: boolean,
                voyageVisibleByCreditor: boolean,
                voyageEditableBySkipper: boolean,
                voyageEditableByCreditor: boolean,
                callVisibleByLocationOwner: boolean,
                isRejectStatus: boolean,
                isAcceptStatus: boolean,
                notifySkippers: boolean,
                notifyShipManagers: boolean,
                notifyShipOwners: boolean,
                notifyOperators: boolean,
                notifyCustomers: boolean,
                notifyTerminals: boolean,
                isCustomerNominatingStatus: boolean,
                isSkipperNominatingStatus: boolean,
                includeInNominationExport: boolean,
                laytimeStartStatus: boolean,
                laytimeEndStatus: boolean,
                requireDocuments: boolean,
                showConfirmMessage: boolean,
                expiringStatus: boolean,
                isActionStatus: boolean,
                requireTanks: boolean,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean,
                  type?: Types.SendDocumentType | null,
                  target?: Types.DocumentTarget | null
                } | null,
                translations?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                confirmMessages?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                rules?: Array<{
                  __typename?: 'Rule',
                  id: number,
                  ifFitsStatusFlow: boolean,
                  ifNotAppliedBefore: boolean,
                  ruleType: {
                    __typename?: 'RuleType',
                    name: Types.StatusRule
                  },
                  targetStatus: {
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    supplierRequired: boolean,
                    description: string,
                    sendDocument?: {
                      __typename?: 'SendDocumentStatus',
                      enabled: boolean
                    } | null
                  }
                }> | null,
                successiveStatuses: Array<{
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  description: string,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean
                }>
              }
            } | null
          }>,
          charter?: {
            __typename?: 'SalesCharter',
            id: number,
            charterNumber: string,
            type: Types.CharterType,
            purchaseCharter?: {
              __typename?: 'PurchaseCharter',
              id: number,
              customerReference?: string | null
            } | null
          } | null,
          product?: {
            __typename?: 'Product',
            id: number,
            name: string,
            description?: string | null,
            productInstructionsForVessel?: string | null,
            heatingInstructionsForVessel?: string | null,
            isDangerousGood?: boolean | null,
            documents?: Array<{
              __typename?: 'Document',
              id: number,
              documentType?: string | null,
              type: string,
              active?: boolean | null
            }> | null
          } | null,
          customerTransportDocument?: {
            __typename?: 'Document',
            id: number
          } | null,
          supplier?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          consignor?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          consignee?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          tanks: Array<{
            __typename?: 'Tank',
            id: number,
            position: Types.TankPosition,
            positionNumber: number,
            capacityM3?: number | null
          }>
        },
        documents: Array<{
          __typename?: 'Document',
          documentEntity: Types.DocumentEntity
        }>,
        surveyor?: {
          __typename?: 'Relation',
          id: number,
          name: string,
          contacts: Array<{
            __typename?: 'Contact',
            id: number,
            name?: string | null,
            telephone?: string | null
          }>
        } | null,
        connectingShipPortVisit?: {
          __typename?: 'ConnectingShipPortVisit',
          id: number,
          from?: number | null,
          until?: number | null,
          lastUpdateFromAgentOn?: number | null,
          ship: {
            __typename?: 'Ship',
            id: number,
            name: string,
            planningNotes?: string | null
          },
          location: {
            __typename?: 'Location',
            id: number,
            description: string,
            type: Types.LocationType
          },
          agent?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          connectingShipBerthings?: Array<{
            __typename?: 'ConnectingShipBerthing',
            id?: number | null,
            location?: {
              __typename?: 'Location',
              id: number,
              description: string,
              type: Types.LocationType
            } | null,
            window?: {
              __typename?: 'TimeWindow',
              from?: number | null,
              to?: number | null
            } | null
          }> | null
        } | null,
        connectingShipBerthing?: {
          __typename?: 'ConnectingShipBerthing',
          id?: number | null,
          location?: {
            __typename?: 'Location',
            id: number,
            description: string,
            type: Types.LocationType
          } | null,
          window?: {
            __typename?: 'TimeWindow',
            from?: number | null,
            to?: number | null
          } | null
        } | null,
        measurements: {
          __typename?: 'Measurements',
          locationWeight?: number | null,
          locationWeightUnit?: Types.WeightUnit | null,
          skipperWeight?: number | null,
          skipperWeightUnit?: Types.WeightUnit | null,
          locationVolume?: number | null,
          locationVolumeUnit?: Types.VolumeUnit | null,
          skipperVolume?: number | null,
          skipperVolumeUnit?: Types.VolumeUnit | null,
          ambientVolume?: number | null,
          relativeDensity?: number | null,
          productTemperature?: number | null,
          actualConsignor?: string | null,
          actualConsignee?: string | null,
          protest?: boolean | null
        }
      }>,
      lastStatusChange?: {
        __typename?: 'StatusChange',
        id: number,
        actualTime?: number | null,
        actualTimeOriginal?: number | null,
        actualTimeOverride?: number | null,
        estimateTime?: number | null,
        comment?: string | null,
        skipperComment?: string | null,
        timestamp?: number | null,
        appliedBy?: string | null,
        deletable: boolean,
        communicatedToCustomer?: number | null,
        status: {
          __typename?: 'Status',
          id: number,
          statusOrder?: number | null,
          cargoActionType?: Types.CallType | null,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          description: string,
          type: Types.StatusType,
          color: string,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }>,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null
        },
        supplier?: {
          __typename?: 'Relation',
          id: number,
          name: string
        } | null,
        origin?: {
          __typename?: 'StatusChange',
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }
        } | null
      } | null,
      statusChanges: Array<{
        __typename?: 'StatusChange',
        id: number,
        actualTime?: number | null,
        actualTimeOriginal?: number | null,
        actualTimeOverride?: number | null,
        estimateTime?: number | null,
        comment?: string | null,
        skipperComment?: string | null,
        timestamp?: number | null,
        appliedBy?: string | null,
        deletable: boolean,
        communicatedToCustomer?: number | null,
        status: {
          __typename?: 'Status',
          id: number,
          statusOrder?: number | null,
          cargoActionType?: Types.CallType | null,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          description: string,
          type: Types.StatusType,
          color: string,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }>,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null
        },
        supplier?: {
          __typename?: 'Relation',
          id: number,
          name: string
        } | null,
        origin?: {
          __typename?: 'StatusChange',
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }
        } | null
      }>,
      expectedCargos: Array<{
        __typename?: 'ExpectedCargo',
        id: number,
        actionType: Types.CallType,
        amount: number,
        full: boolean,
        dischargingLocation?: {
          __typename?: 'Location',
          id: number,
          description: string,
          type: Types.LocationType,
          locationGroups: Array<{
            __typename?: 'Location',
            code?: string | null,
            id: number,
            description: string,
            type: Types.LocationType
          }>
        } | null,
        containerType: {
          __typename?: 'ContainerType',
          isoTypeCode: string,
          teu: number
        }
      }>
    }>,
    ship: {
      __typename?: 'Ship',
      bargeType?: Types.BargeType | null,
      id: number,
      name: string,
      operator?: {
        __typename?: 'Relation',
        id: number,
        name: string,
        isApplicationRelation?: boolean | null
      } | null
    },
    purchaseCharters?: Array<{
      __typename?: 'PurchaseCharter',
      id: number,
      charterNumber: string,
      type: Types.CharterType,
      subtype: Types.CharterSubtype
    }> | null,
    scopeIn?: {
      __typename?: 'Scope',
      desired?: number | null,
      planned?: number | null,
      actual?: number | null,
      systemActual?: number | null,
      expected?: number | null,
      systemExpected?: number | null,
      expectedLocation?: {
        __typename?: 'Location',
        id: number,
        description: string,
        locationGroups: Array<{
          __typename?: 'Location',
          type: Types.LocationType,
          description: string
        }>
      } | null,
      plannedLocation?: {
        __typename?: 'Location',
        id: number,
        description: string,
        locationGroups: Array<{
          __typename?: 'Location',
          type: Types.LocationType,
          description: string
        }>
      } | null,
      actualLocation?: {
        __typename?: 'Location',
        id: number,
        description: string,
        locationGroups: Array<{
          __typename?: 'Location',
          type: Types.LocationType,
          description: string
        }>
      } | null
    } | null,
    scopeOut?: {
      __typename?: 'Scope',
      desired?: number | null,
      planned?: number | null,
      actual?: number | null,
      systemActual?: number | null,
      expected?: number | null,
      systemExpected?: number | null,
      expectedLocation?: {
        __typename?: 'Location',
        id: number,
        description: string
      } | null,
      plannedLocation?: {
        __typename?: 'Location',
        id: number,
        description: string
      } | null,
      actualLocation?: {
        __typename?: 'Location',
        id: number,
        description: string
      } | null
    } | null,
    creditor?: {
      __typename?: 'Relation',
      id: number,
      name: string
    } | null,
    cargoCharter?: {
      __typename?: 'SalesCharter',
      id: number,
      charterNumber: string,
      type: Types.CharterType
    } | null,
    schedule?: {
      __typename?: 'SailingSchedule',
      id: number,
      schedule: string
    } | null,
    lastStatusChange?: {
      __typename?: 'StatusChange',
      id: number,
      actualTime?: number | null,
      actualTimeOriginal?: number | null,
      actualTimeOverride?: number | null,
      estimateTime?: number | null,
      comment?: string | null,
      skipperComment?: string | null,
      timestamp?: number | null,
      appliedBy?: string | null,
      deletable: boolean,
      communicatedToCustomer?: number | null,
      status: {
        __typename?: 'Status',
        id: number,
        description: string,
        type: Types.StatusType,
        cargoActionType?: Types.CallType | null,
        color: string,
        statusOrder?: number | null,
        supplierRequired: boolean,
        skipperRequiredFillInSailingReport: boolean,
        skipperRequiredFillInWeightVolume: boolean,
        applyByCustomer: boolean,
        applyBySkipper: boolean,
        applyByTerminal: boolean,
        requireActualTime: Types.StatusActualTimeType,
        estimateType?: Types.StatusEstimateType | null,
        estimateRequirement: Types.StatusEstimateRequirement,
        shouldLoadOnTerminal: boolean,
        closedStatus: boolean,
        cancelledStatus: boolean,
        loadedStatus: boolean,
        dischargedStatus: boolean,
        finishedStatus: boolean,
        allowComment: boolean,
        allowSkipperComment: boolean,
        shouldUpdateJDE: boolean,
        isInProgress: boolean,
        voyageVisibleBySkipper: boolean,
        voyageVisibleByCreditor: boolean,
        voyageEditableBySkipper: boolean,
        voyageEditableByCreditor: boolean,
        callVisibleByLocationOwner: boolean,
        isRejectStatus: boolean,
        isAcceptStatus: boolean,
        notifySkippers: boolean,
        notifyShipManagers: boolean,
        notifyShipOwners: boolean,
        notifyOperators: boolean,
        notifyCustomers: boolean,
        notifyTerminals: boolean,
        isCustomerNominatingStatus: boolean,
        isSkipperNominatingStatus: boolean,
        includeInNominationExport: boolean,
        laytimeStartStatus: boolean,
        laytimeEndStatus: boolean,
        requireDocuments: boolean,
        showConfirmMessage: boolean,
        expiringStatus: boolean,
        isActionStatus: boolean,
        requireTanks: boolean,
        successiveStatuses: Array<{
          __typename?: 'Status',
          id: number,
          type: Types.StatusType,
          description: string,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }>,
        sendDocument?: {
          __typename?: 'SendDocumentStatus',
          enabled: boolean,
          type?: Types.SendDocumentType | null,
          target?: Types.DocumentTarget | null
        } | null,
        translations?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        confirmMessages?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        rules?: Array<{
          __typename?: 'Rule',
          id: number,
          ifFitsStatusFlow: boolean,
          ifNotAppliedBefore: boolean,
          ruleType: {
            __typename?: 'RuleType',
            name: Types.StatusRule
          },
          targetStatus: {
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            supplierRequired: boolean,
            description: string,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean
            } | null
          }
        }> | null
      },
      supplier?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      origin?: {
        __typename?: 'StatusChange',
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          type: Types.StatusType,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }
      } | null
    } | null,
    statusChanges: Array<{
      __typename?: 'StatusChange',
      id: number,
      actualTime?: number | null,
      actualTimeOriginal?: number | null,
      actualTimeOverride?: number | null,
      estimateTime?: number | null,
      comment?: string | null,
      skipperComment?: string | null,
      timestamp?: number | null,
      appliedBy?: string | null,
      deletable: boolean,
      communicatedToCustomer?: number | null,
      status: {
        __typename?: 'Status',
        id: number,
        description: string,
        type: Types.StatusType,
        cargoActionType?: Types.CallType | null,
        color: string,
        statusOrder?: number | null,
        supplierRequired: boolean,
        skipperRequiredFillInSailingReport: boolean,
        skipperRequiredFillInWeightVolume: boolean,
        applyByCustomer: boolean,
        applyBySkipper: boolean,
        applyByTerminal: boolean,
        requireActualTime: Types.StatusActualTimeType,
        estimateType?: Types.StatusEstimateType | null,
        estimateRequirement: Types.StatusEstimateRequirement,
        shouldLoadOnTerminal: boolean,
        closedStatus: boolean,
        cancelledStatus: boolean,
        loadedStatus: boolean,
        dischargedStatus: boolean,
        finishedStatus: boolean,
        allowComment: boolean,
        allowSkipperComment: boolean,
        shouldUpdateJDE: boolean,
        isInProgress: boolean,
        voyageVisibleBySkipper: boolean,
        voyageVisibleByCreditor: boolean,
        voyageEditableBySkipper: boolean,
        voyageEditableByCreditor: boolean,
        callVisibleByLocationOwner: boolean,
        isRejectStatus: boolean,
        isAcceptStatus: boolean,
        notifySkippers: boolean,
        notifyShipManagers: boolean,
        notifyShipOwners: boolean,
        notifyOperators: boolean,
        notifyCustomers: boolean,
        notifyTerminals: boolean,
        isCustomerNominatingStatus: boolean,
        isSkipperNominatingStatus: boolean,
        includeInNominationExport: boolean,
        laytimeStartStatus: boolean,
        laytimeEndStatus: boolean,
        requireDocuments: boolean,
        showConfirmMessage: boolean,
        expiringStatus: boolean,
        isActionStatus: boolean,
        requireTanks: boolean,
        successiveStatuses: Array<{
          __typename?: 'Status',
          id: number,
          type: Types.StatusType,
          description: string,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }>,
        sendDocument?: {
          __typename?: 'SendDocumentStatus',
          enabled: boolean,
          type?: Types.SendDocumentType | null,
          target?: Types.DocumentTarget | null
        } | null,
        translations?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        confirmMessages?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        rules?: Array<{
          __typename?: 'Rule',
          id: number,
          ifFitsStatusFlow: boolean,
          ifNotAppliedBefore: boolean,
          ruleType: {
            __typename?: 'RuleType',
            name: Types.StatusRule
          },
          targetStatus: {
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            supplierRequired: boolean,
            description: string,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean
            } | null
          }
        }> | null
      },
      supplier?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      origin?: {
        __typename?: 'StatusChange',
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          type: Types.StatusType,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }
      } | null
    }>,
    from?: {
      __typename?: 'Location',
      type: Types.LocationType,
      id: number,
      description: string
    } | null,
    to?: {
      __typename?: 'Location',
      type: Types.LocationType,
      id: number,
      description: string
    } | null
  } | null
};

export type VoyageDetailsQueryVariables = Types.Exact<{
  id: Types.Scalars['Long']['input'];
}>;


export type VoyageDetailsQuery = {
  __typename?: 'Query',
  voyage?: {
    __typename?: 'Voyage',
    id: number,
    voyageNumber: string,
    inactivityType?: Types.InactivityType | null,
    isBallast: boolean,
    start?: number | null,
    end?: number | null,
    lastShippedProductsFreeText: Array<string>,
    ship: {
      __typename?: 'Ship',
      bargeType?: Types.BargeType | null,
      id: number,
      name: string,
      operator?: {
        __typename?: 'Relation',
        id: number,
        name: string,
        isApplicationRelation?: boolean | null
      } | null
    },
    calls: Array<{
      __typename?: 'Call',
      id: number,
      expectedLoadingAmount?: number | null,
      expectedDischargingAmount?: number | null,
      expectedLoadingTeu?: number | null,
      expectedDischargingTeu?: number | null,
      nrLoadingCargos: number,
      nrDischargingCargos: number,
      callLoadingTeu?: number | null,
      callDischargingTeu?: number | null,
      simulatedTimestamp: boolean,
      pta?: number | null,
      ptd?: number | null,
      ata?: number | null,
      atd?: number | null,
      eta?: number | null,
      etd?: number | null,
      loadedWeight?: number | null,
      dischargedWeight?: number | null,
      etso?: number | null,
      eteo?: number | null,
      atso?: number | null,
      ateo?: number | null,
      etfm?: number | null,
      etlm?: number | null,
      atfm?: number | null,
      atlm?: number | null,
      atn?: number | null,
      dtn?: number | null,
      systemAta?: number | null,
      systemAtd?: number | null,
      systemEta?: number | null,
      systemEtd?: number | null,
      cargos: Array<{
        __typename?: 'CargoAction',
        start?: number | null,
        end?: number | null,
        displayAsWindow?: boolean | null,
        id: number,
        type: Types.CallType,
        timesheetNote?: string | null,
        simulatedTimestamp?: boolean | null,
        weight?: number | null,
        volume?: number | null,
        limitType?: Types.LimitType | null,
        limitValue?: number | null,
        notes?: string | null,
        reference?: string | null,
        shipToShip?: boolean | null,
        connectingVisitNotes?: string | null,
        location?: {
          __typename?: 'Location',
          displayCode?: string | null,
          code?: string | null,
          notes?: string | null,
          uabRegistration?: boolean | null,
          id: number,
          description: string,
          type: Types.LocationType,
          contacts?: Array<{
            __typename?: 'Contact',
            id: number,
            name?: string | null,
            telephone?: string | null
          }> | null,
          locationGroups: Array<{
            __typename?: 'Location',
            code?: string | null,
            id: number,
            description: string,
            type: Types.LocationType
          }>
        } | null,
        cargo: {
          __typename?: 'Cargo',
          id: number,
          cargoNumber?: string | null,
          containerNumber?: string | null,
          weight?: number | null,
          volume?: number | null,
          isWeightPrimary: boolean,
          isVolumePrimary: boolean,
          waterLevelOptimised: boolean,
          weightToleranceType?: Types.WeightToleranceType | null,
          weightOptionType?: Types.WeightOptionType | null,
          weightOptionPercentage?: number | null,
          declaredFinalWeight?: number | null,
          isHoseRentalRequired: boolean,
          isInhibitedProduct: boolean,
          isNitrogenBlanketingRequired: boolean,
          isNitrogenPurgingRequired: boolean,
          isTemperatureControlRequired: boolean,
          isCleaningRequired: boolean,
          loadingReference?: string | null,
          dischargingReference?: string | null,
          lastStatusChange?: {
            __typename?: 'StatusChange',
            id: number,
            actualTime?: number | null,
            actualTimeOriginal?: number | null,
            actualTimeOverride?: number | null,
            estimateTime?: number | null,
            comment?: string | null,
            skipperComment?: string | null,
            timestamp?: number | null,
            appliedBy?: string | null,
            deletable: boolean,
            communicatedToCustomer?: number | null,
            status: {
              __typename?: 'Status',
              id: number,
              statusOrder?: number | null,
              cargoActionType?: Types.CallType | null,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              description: string,
              type: Types.StatusType,
              color: string,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean,
                cargoActionType?: Types.CallType | null,
                color: string,
                statusOrder?: number | null,
                supplierRequired: boolean,
                skipperRequiredFillInSailingReport: boolean,
                skipperRequiredFillInWeightVolume: boolean,
                requireActualTime: Types.StatusActualTimeType,
                estimateType?: Types.StatusEstimateType | null,
                estimateRequirement: Types.StatusEstimateRequirement,
                shouldLoadOnTerminal: boolean,
                closedStatus: boolean,
                cancelledStatus: boolean,
                loadedStatus: boolean,
                dischargedStatus: boolean,
                finishedStatus: boolean,
                allowComment: boolean,
                allowSkipperComment: boolean,
                shouldUpdateJDE: boolean,
                isInProgress: boolean,
                voyageVisibleBySkipper: boolean,
                voyageVisibleByCreditor: boolean,
                voyageEditableBySkipper: boolean,
                voyageEditableByCreditor: boolean,
                callVisibleByLocationOwner: boolean,
                isRejectStatus: boolean,
                isAcceptStatus: boolean,
                notifySkippers: boolean,
                notifyShipManagers: boolean,
                notifyShipOwners: boolean,
                notifyOperators: boolean,
                notifyCustomers: boolean,
                notifyTerminals: boolean,
                isCustomerNominatingStatus: boolean,
                isSkipperNominatingStatus: boolean,
                includeInNominationExport: boolean,
                laytimeStartStatus: boolean,
                laytimeEndStatus: boolean,
                requireDocuments: boolean,
                showConfirmMessage: boolean,
                expiringStatus: boolean,
                isActionStatus: boolean,
                requireTanks: boolean,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean,
                  type?: Types.SendDocumentType | null,
                  target?: Types.DocumentTarget | null
                } | null,
                translations?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                confirmMessages?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                rules?: Array<{
                  __typename?: 'Rule',
                  id: number,
                  ifFitsStatusFlow: boolean,
                  ifNotAppliedBefore: boolean,
                  ruleType: {
                    __typename?: 'RuleType',
                    name: Types.StatusRule
                  },
                  targetStatus: {
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    supplierRequired: boolean,
                    description: string,
                    sendDocument?: {
                      __typename?: 'SendDocumentStatus',
                      enabled: boolean
                    } | null
                  }
                }> | null,
                successiveStatuses: Array<{
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  description: string,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean
                }>
              }>,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null
            },
            supplier?: {
              __typename?: 'Relation',
              id: number,
              name: string
            } | null,
            origin?: {
              __typename?: 'StatusChange',
              status: {
                __typename?: 'Status',
                id: number,
                description: string,
                type: Types.StatusType,
                cargoActionType?: Types.CallType | null,
                color: string,
                statusOrder?: number | null,
                supplierRequired: boolean,
                skipperRequiredFillInSailingReport: boolean,
                skipperRequiredFillInWeightVolume: boolean,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean,
                requireActualTime: Types.StatusActualTimeType,
                estimateType?: Types.StatusEstimateType | null,
                estimateRequirement: Types.StatusEstimateRequirement,
                shouldLoadOnTerminal: boolean,
                closedStatus: boolean,
                cancelledStatus: boolean,
                loadedStatus: boolean,
                dischargedStatus: boolean,
                finishedStatus: boolean,
                allowComment: boolean,
                allowSkipperComment: boolean,
                shouldUpdateJDE: boolean,
                isInProgress: boolean,
                voyageVisibleBySkipper: boolean,
                voyageVisibleByCreditor: boolean,
                voyageEditableBySkipper: boolean,
                voyageEditableByCreditor: boolean,
                callVisibleByLocationOwner: boolean,
                isRejectStatus: boolean,
                isAcceptStatus: boolean,
                notifySkippers: boolean,
                notifyShipManagers: boolean,
                notifyShipOwners: boolean,
                notifyOperators: boolean,
                notifyCustomers: boolean,
                notifyTerminals: boolean,
                isCustomerNominatingStatus: boolean,
                isSkipperNominatingStatus: boolean,
                includeInNominationExport: boolean,
                laytimeStartStatus: boolean,
                laytimeEndStatus: boolean,
                requireDocuments: boolean,
                showConfirmMessage: boolean,
                expiringStatus: boolean,
                isActionStatus: boolean,
                requireTanks: boolean,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean,
                  type?: Types.SendDocumentType | null,
                  target?: Types.DocumentTarget | null
                } | null,
                translations?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                confirmMessages?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                rules?: Array<{
                  __typename?: 'Rule',
                  id: number,
                  ifFitsStatusFlow: boolean,
                  ifNotAppliedBefore: boolean,
                  ruleType: {
                    __typename?: 'RuleType',
                    name: Types.StatusRule
                  },
                  targetStatus: {
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    supplierRequired: boolean,
                    description: string,
                    sendDocument?: {
                      __typename?: 'SendDocumentStatus',
                      enabled: boolean
                    } | null
                  }
                }> | null,
                successiveStatuses: Array<{
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  description: string,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean
                }>
              }
            } | null
          } | null,
          statusChanges: Array<{
            __typename?: 'StatusChange',
            id: number,
            actualTime?: number | null,
            actualTimeOriginal?: number | null,
            actualTimeOverride?: number | null,
            estimateTime?: number | null,
            comment?: string | null,
            skipperComment?: string | null,
            timestamp?: number | null,
            appliedBy?: string | null,
            deletable: boolean,
            communicatedToCustomer?: number | null,
            status: {
              __typename?: 'Status',
              id: number,
              statusOrder?: number | null,
              cargoActionType?: Types.CallType | null,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              description: string,
              type: Types.StatusType,
              color: string,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean,
                cargoActionType?: Types.CallType | null,
                color: string,
                statusOrder?: number | null,
                supplierRequired: boolean,
                skipperRequiredFillInSailingReport: boolean,
                skipperRequiredFillInWeightVolume: boolean,
                requireActualTime: Types.StatusActualTimeType,
                estimateType?: Types.StatusEstimateType | null,
                estimateRequirement: Types.StatusEstimateRequirement,
                shouldLoadOnTerminal: boolean,
                closedStatus: boolean,
                cancelledStatus: boolean,
                loadedStatus: boolean,
                dischargedStatus: boolean,
                finishedStatus: boolean,
                allowComment: boolean,
                allowSkipperComment: boolean,
                shouldUpdateJDE: boolean,
                isInProgress: boolean,
                voyageVisibleBySkipper: boolean,
                voyageVisibleByCreditor: boolean,
                voyageEditableBySkipper: boolean,
                voyageEditableByCreditor: boolean,
                callVisibleByLocationOwner: boolean,
                isRejectStatus: boolean,
                isAcceptStatus: boolean,
                notifySkippers: boolean,
                notifyShipManagers: boolean,
                notifyShipOwners: boolean,
                notifyOperators: boolean,
                notifyCustomers: boolean,
                notifyTerminals: boolean,
                isCustomerNominatingStatus: boolean,
                isSkipperNominatingStatus: boolean,
                includeInNominationExport: boolean,
                laytimeStartStatus: boolean,
                laytimeEndStatus: boolean,
                requireDocuments: boolean,
                showConfirmMessage: boolean,
                expiringStatus: boolean,
                isActionStatus: boolean,
                requireTanks: boolean,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean,
                  type?: Types.SendDocumentType | null,
                  target?: Types.DocumentTarget | null
                } | null,
                translations?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                confirmMessages?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                rules?: Array<{
                  __typename?: 'Rule',
                  id: number,
                  ifFitsStatusFlow: boolean,
                  ifNotAppliedBefore: boolean,
                  ruleType: {
                    __typename?: 'RuleType',
                    name: Types.StatusRule
                  },
                  targetStatus: {
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    supplierRequired: boolean,
                    description: string,
                    sendDocument?: {
                      __typename?: 'SendDocumentStatus',
                      enabled: boolean
                    } | null
                  }
                }> | null,
                successiveStatuses: Array<{
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  description: string,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean
                }>
              }>,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null
            },
            supplier?: {
              __typename?: 'Relation',
              id: number,
              name: string
            } | null,
            origin?: {
              __typename?: 'StatusChange',
              status: {
                __typename?: 'Status',
                id: number,
                description: string,
                type: Types.StatusType,
                cargoActionType?: Types.CallType | null,
                color: string,
                statusOrder?: number | null,
                supplierRequired: boolean,
                skipperRequiredFillInSailingReport: boolean,
                skipperRequiredFillInWeightVolume: boolean,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean,
                requireActualTime: Types.StatusActualTimeType,
                estimateType?: Types.StatusEstimateType | null,
                estimateRequirement: Types.StatusEstimateRequirement,
                shouldLoadOnTerminal: boolean,
                closedStatus: boolean,
                cancelledStatus: boolean,
                loadedStatus: boolean,
                dischargedStatus: boolean,
                finishedStatus: boolean,
                allowComment: boolean,
                allowSkipperComment: boolean,
                shouldUpdateJDE: boolean,
                isInProgress: boolean,
                voyageVisibleBySkipper: boolean,
                voyageVisibleByCreditor: boolean,
                voyageEditableBySkipper: boolean,
                voyageEditableByCreditor: boolean,
                callVisibleByLocationOwner: boolean,
                isRejectStatus: boolean,
                isAcceptStatus: boolean,
                notifySkippers: boolean,
                notifyShipManagers: boolean,
                notifyShipOwners: boolean,
                notifyOperators: boolean,
                notifyCustomers: boolean,
                notifyTerminals: boolean,
                isCustomerNominatingStatus: boolean,
                isSkipperNominatingStatus: boolean,
                includeInNominationExport: boolean,
                laytimeStartStatus: boolean,
                laytimeEndStatus: boolean,
                requireDocuments: boolean,
                showConfirmMessage: boolean,
                expiringStatus: boolean,
                isActionStatus: boolean,
                requireTanks: boolean,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean,
                  type?: Types.SendDocumentType | null,
                  target?: Types.DocumentTarget | null
                } | null,
                translations?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                confirmMessages?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                rules?: Array<{
                  __typename?: 'Rule',
                  id: number,
                  ifFitsStatusFlow: boolean,
                  ifNotAppliedBefore: boolean,
                  ruleType: {
                    __typename?: 'RuleType',
                    name: Types.StatusRule
                  },
                  targetStatus: {
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    supplierRequired: boolean,
                    description: string,
                    sendDocument?: {
                      __typename?: 'SendDocumentStatus',
                      enabled: boolean
                    } | null
                  }
                }> | null,
                successiveStatuses: Array<{
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  description: string,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean
                }>
              }
            } | null
          }>,
          charter?: {
            __typename?: 'SalesCharter',
            id: number,
            charterNumber: string,
            type: Types.CharterType,
            purchaseCharter?: {
              __typename?: 'PurchaseCharter',
              id: number,
              customerReference?: string | null
            } | null
          } | null,
          product?: {
            __typename?: 'Product',
            id: number,
            name: string,
            description?: string | null,
            productInstructionsForVessel?: string | null,
            heatingInstructionsForVessel?: string | null,
            isDangerousGood?: boolean | null,
            documents?: Array<{
              __typename?: 'Document',
              id: number,
              documentType?: string | null,
              type: string,
              active?: boolean | null
            }> | null
          } | null,
          customerTransportDocument?: {
            __typename?: 'Document',
            id: number
          } | null,
          supplier?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          consignor?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          consignee?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          tanks: Array<{
            __typename?: 'Tank',
            id: number,
            position: Types.TankPosition,
            positionNumber: number,
            capacityM3?: number | null
          }>
        },
        documents: Array<{
          __typename?: 'Document',
          documentEntity: Types.DocumentEntity
        }>,
        surveyor?: {
          __typename?: 'Relation',
          id: number,
          name: string,
          contacts: Array<{
            __typename?: 'Contact',
            id: number,
            name?: string | null,
            telephone?: string | null
          }>
        } | null,
        connectingShipPortVisit?: {
          __typename?: 'ConnectingShipPortVisit',
          id: number,
          from?: number | null,
          until?: number | null,
          lastUpdateFromAgentOn?: number | null,
          ship: {
            __typename?: 'Ship',
            id: number,
            name: string,
            planningNotes?: string | null
          },
          location: {
            __typename?: 'Location',
            id: number,
            description: string,
            type: Types.LocationType
          },
          agent?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          connectingShipBerthings?: Array<{
            __typename?: 'ConnectingShipBerthing',
            id?: number | null,
            location?: {
              __typename?: 'Location',
              id: number,
              description: string,
              type: Types.LocationType
            } | null,
            window?: {
              __typename?: 'TimeWindow',
              from?: number | null,
              to?: number | null
            } | null
          }> | null
        } | null,
        connectingShipBerthing?: {
          __typename?: 'ConnectingShipBerthing',
          id?: number | null,
          location?: {
            __typename?: 'Location',
            id: number,
            description: string,
            type: Types.LocationType
          } | null,
          window?: {
            __typename?: 'TimeWindow',
            from?: number | null,
            to?: number | null
          } | null
        } | null,
        measurements: {
          __typename?: 'Measurements',
          locationWeight?: number | null,
          locationWeightUnit?: Types.WeightUnit | null,
          skipperWeight?: number | null,
          skipperWeightUnit?: Types.WeightUnit | null,
          locationVolume?: number | null,
          locationVolumeUnit?: Types.VolumeUnit | null,
          skipperVolume?: number | null,
          skipperVolumeUnit?: Types.VolumeUnit | null,
          ambientVolume?: number | null,
          relativeDensity?: number | null,
          productTemperature?: number | null,
          actualConsignor?: string | null,
          actualConsignee?: string | null,
          protest?: boolean | null
        }
      }>,
      location: {
        __typename?: 'Location',
        type: Types.LocationType,
        id: number,
        description: string,
        locationGroups: Array<{
          __typename?: 'Location',
          code?: string | null,
          id: number,
          description: string,
          type: Types.LocationType
        }>
      },
      lastStatusChange?: {
        __typename?: 'StatusChange',
        id: number,
        actualTime?: number | null,
        actualTimeOriginal?: number | null,
        actualTimeOverride?: number | null,
        estimateTime?: number | null,
        comment?: string | null,
        skipperComment?: string | null,
        timestamp?: number | null,
        appliedBy?: string | null,
        deletable: boolean,
        communicatedToCustomer?: number | null,
        status: {
          __typename?: 'Status',
          id: number,
          statusOrder?: number | null,
          cargoActionType?: Types.CallType | null,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          description: string,
          type: Types.StatusType,
          color: string,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }>,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null
        },
        supplier?: {
          __typename?: 'Relation',
          id: number,
          name: string
        } | null,
        origin?: {
          __typename?: 'StatusChange',
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }
        } | null
      } | null,
      statusChanges: Array<{
        __typename?: 'StatusChange',
        id: number,
        actualTime?: number | null,
        actualTimeOriginal?: number | null,
        actualTimeOverride?: number | null,
        estimateTime?: number | null,
        comment?: string | null,
        skipperComment?: string | null,
        timestamp?: number | null,
        appliedBy?: string | null,
        deletable: boolean,
        communicatedToCustomer?: number | null,
        status: {
          __typename?: 'Status',
          id: number,
          statusOrder?: number | null,
          cargoActionType?: Types.CallType | null,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          description: string,
          type: Types.StatusType,
          color: string,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }>,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null
        },
        supplier?: {
          __typename?: 'Relation',
          id: number,
          name: string
        } | null,
        origin?: {
          __typename?: 'StatusChange',
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }
        } | null
      }>,
      expectedCargos: Array<{
        __typename?: 'ExpectedCargo',
        id: number,
        actionType: Types.CallType,
        amount: number,
        full: boolean,
        dischargingLocation?: {
          __typename?: 'Location',
          id: number,
          description: string,
          type: Types.LocationType,
          locationGroups: Array<{
            __typename?: 'Location',
            code?: string | null,
            id: number,
            description: string,
            type: Types.LocationType
          }>
        } | null,
        containerType: {
          __typename?: 'ContainerType',
          isoTypeCode: string,
          teu: number
        }
      }>
    }>,
    purchaseCharters?: Array<{
      __typename?: 'PurchaseCharter',
      id: number,
      charterNumber: string,
      type: Types.CharterType,
      subtype: Types.CharterSubtype
    }> | null,
    scopeIn?: {
      __typename?: 'Scope',
      desired?: number | null,
      planned?: number | null,
      actual?: number | null,
      systemActual?: number | null,
      expected?: number | null,
      systemExpected?: number | null,
      expectedLocation?: {
        __typename?: 'Location',
        id: number,
        description: string,
        locationGroups: Array<{
          __typename?: 'Location',
          type: Types.LocationType,
          description: string
        }>
      } | null,
      plannedLocation?: {
        __typename?: 'Location',
        id: number,
        description: string,
        locationGroups: Array<{
          __typename?: 'Location',
          type: Types.LocationType,
          description: string
        }>
      } | null,
      actualLocation?: {
        __typename?: 'Location',
        id: number,
        description: string,
        locationGroups: Array<{
          __typename?: 'Location',
          type: Types.LocationType,
          description: string
        }>
      } | null
    } | null,
    scopeOut?: {
      __typename?: 'Scope',
      desired?: number | null,
      planned?: number | null,
      actual?: number | null,
      systemActual?: number | null,
      expected?: number | null,
      systemExpected?: number | null,
      expectedLocation?: {
        __typename?: 'Location',
        id: number,
        description: string
      } | null,
      plannedLocation?: {
        __typename?: 'Location',
        id: number,
        description: string
      } | null,
      actualLocation?: {
        __typename?: 'Location',
        id: number,
        description: string
      } | null
    } | null,
    cargos: Array<{
      __typename?: 'Cargo',
      id: number,
      cargoNumber?: string | null,
      containerNumber?: string | null,
      product?: {
        __typename?: 'Product',
        name: string
      } | null
    }>,
    creditor?: {
      __typename?: 'Relation',
      id: number,
      name: string
    } | null,
    cargoCharter?: {
      __typename?: 'SalesCharter',
      id: number,
      charterNumber: string,
      type: Types.CharterType
    } | null,
    schedule?: {
      __typename?: 'SailingSchedule',
      id: number,
      schedule: string
    } | null,
    lastStatusChange?: {
      __typename?: 'StatusChange',
      id: number,
      actualTime?: number | null,
      actualTimeOriginal?: number | null,
      actualTimeOverride?: number | null,
      estimateTime?: number | null,
      comment?: string | null,
      skipperComment?: string | null,
      timestamp?: number | null,
      appliedBy?: string | null,
      deletable: boolean,
      communicatedToCustomer?: number | null,
      status: {
        __typename?: 'Status',
        id: number,
        description: string,
        type: Types.StatusType,
        cargoActionType?: Types.CallType | null,
        color: string,
        statusOrder?: number | null,
        supplierRequired: boolean,
        skipperRequiredFillInSailingReport: boolean,
        skipperRequiredFillInWeightVolume: boolean,
        applyByCustomer: boolean,
        applyBySkipper: boolean,
        applyByTerminal: boolean,
        requireActualTime: Types.StatusActualTimeType,
        estimateType?: Types.StatusEstimateType | null,
        estimateRequirement: Types.StatusEstimateRequirement,
        shouldLoadOnTerminal: boolean,
        closedStatus: boolean,
        cancelledStatus: boolean,
        loadedStatus: boolean,
        dischargedStatus: boolean,
        finishedStatus: boolean,
        allowComment: boolean,
        allowSkipperComment: boolean,
        shouldUpdateJDE: boolean,
        isInProgress: boolean,
        voyageVisibleBySkipper: boolean,
        voyageVisibleByCreditor: boolean,
        voyageEditableBySkipper: boolean,
        voyageEditableByCreditor: boolean,
        callVisibleByLocationOwner: boolean,
        isRejectStatus: boolean,
        isAcceptStatus: boolean,
        notifySkippers: boolean,
        notifyShipManagers: boolean,
        notifyShipOwners: boolean,
        notifyOperators: boolean,
        notifyCustomers: boolean,
        notifyTerminals: boolean,
        isCustomerNominatingStatus: boolean,
        isSkipperNominatingStatus: boolean,
        includeInNominationExport: boolean,
        laytimeStartStatus: boolean,
        laytimeEndStatus: boolean,
        requireDocuments: boolean,
        showConfirmMessage: boolean,
        expiringStatus: boolean,
        isActionStatus: boolean,
        requireTanks: boolean,
        successiveStatuses: Array<{
          __typename?: 'Status',
          id: number,
          type: Types.StatusType,
          description: string,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }>,
        sendDocument?: {
          __typename?: 'SendDocumentStatus',
          enabled: boolean,
          type?: Types.SendDocumentType | null,
          target?: Types.DocumentTarget | null
        } | null,
        translations?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        confirmMessages?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        rules?: Array<{
          __typename?: 'Rule',
          id: number,
          ifFitsStatusFlow: boolean,
          ifNotAppliedBefore: boolean,
          ruleType: {
            __typename?: 'RuleType',
            name: Types.StatusRule
          },
          targetStatus: {
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            supplierRequired: boolean,
            description: string,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean
            } | null
          }
        }> | null
      },
      supplier?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      origin?: {
        __typename?: 'StatusChange',
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          type: Types.StatusType,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }
      } | null
    } | null,
    statusChanges: Array<{
      __typename?: 'StatusChange',
      id: number,
      actualTime?: number | null,
      actualTimeOriginal?: number | null,
      actualTimeOverride?: number | null,
      estimateTime?: number | null,
      comment?: string | null,
      skipperComment?: string | null,
      timestamp?: number | null,
      appliedBy?: string | null,
      deletable: boolean,
      communicatedToCustomer?: number | null,
      status: {
        __typename?: 'Status',
        id: number,
        description: string,
        type: Types.StatusType,
        cargoActionType?: Types.CallType | null,
        color: string,
        statusOrder?: number | null,
        supplierRequired: boolean,
        skipperRequiredFillInSailingReport: boolean,
        skipperRequiredFillInWeightVolume: boolean,
        applyByCustomer: boolean,
        applyBySkipper: boolean,
        applyByTerminal: boolean,
        requireActualTime: Types.StatusActualTimeType,
        estimateType?: Types.StatusEstimateType | null,
        estimateRequirement: Types.StatusEstimateRequirement,
        shouldLoadOnTerminal: boolean,
        closedStatus: boolean,
        cancelledStatus: boolean,
        loadedStatus: boolean,
        dischargedStatus: boolean,
        finishedStatus: boolean,
        allowComment: boolean,
        allowSkipperComment: boolean,
        shouldUpdateJDE: boolean,
        isInProgress: boolean,
        voyageVisibleBySkipper: boolean,
        voyageVisibleByCreditor: boolean,
        voyageEditableBySkipper: boolean,
        voyageEditableByCreditor: boolean,
        callVisibleByLocationOwner: boolean,
        isRejectStatus: boolean,
        isAcceptStatus: boolean,
        notifySkippers: boolean,
        notifyShipManagers: boolean,
        notifyShipOwners: boolean,
        notifyOperators: boolean,
        notifyCustomers: boolean,
        notifyTerminals: boolean,
        isCustomerNominatingStatus: boolean,
        isSkipperNominatingStatus: boolean,
        includeInNominationExport: boolean,
        laytimeStartStatus: boolean,
        laytimeEndStatus: boolean,
        requireDocuments: boolean,
        showConfirmMessage: boolean,
        expiringStatus: boolean,
        isActionStatus: boolean,
        requireTanks: boolean,
        successiveStatuses: Array<{
          __typename?: 'Status',
          id: number,
          type: Types.StatusType,
          description: string,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }>,
        sendDocument?: {
          __typename?: 'SendDocumentStatus',
          enabled: boolean,
          type?: Types.SendDocumentType | null,
          target?: Types.DocumentTarget | null
        } | null,
        translations?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        confirmMessages?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        rules?: Array<{
          __typename?: 'Rule',
          id: number,
          ifFitsStatusFlow: boolean,
          ifNotAppliedBefore: boolean,
          ruleType: {
            __typename?: 'RuleType',
            name: Types.StatusRule
          },
          targetStatus: {
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            supplierRequired: boolean,
            description: string,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean
            } | null
          }
        }> | null
      },
      supplier?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      origin?: {
        __typename?: 'StatusChange',
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          type: Types.StatusType,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }
      } | null
    }>,
    from?: {
      __typename?: 'Location',
      type: Types.LocationType,
      id: number,
      description: string
    } | null,
    to?: {
      __typename?: 'Location',
      type: Types.LocationType,
      id: number,
      description: string
    } | null
  } | null
};

export type VoyageLogQueryVariables = Types.Exact<{
  id: Types.Scalars['Long']['input'];
}>;


export type VoyageLogQuery = {
  __typename?: 'Query',
  voyageLog: {
    __typename?: 'VoyageLog',
    actualSailingDistanceInKm?: number | null,
    actualSailingMinutes?: number | null,
    gasOilPrice?: number | null,
    estimatedSailingMinutes?: number | null,
    estimatedSailingDistanceInKm?: number | null,
    estimatedFuelConsumption?: number | null,
    actualFuelConsumption?: number | null,
    visitedPorts?: Array<{
      __typename?: 'LoggedGeofence',
      id: number,
      enteredDateTime?: number | null,
      location?: {
        __typename?: 'Location',
        id: number,
        description: string,
        code?: string | null,
        locationGroups: Array<{
          __typename?: 'Location',
          id: number,
          description: string,
          type: Types.LocationType
        }>
      } | null
    } | null> | null
  }
};

export type GetVoyageCallsIdQueryVariables = Types.Exact<{
  id: Types.Scalars['Long']['input'];
}>;


export type GetVoyageCallsIdQuery = {
  __typename?: 'Query',
  voyage?: {
    __typename?: 'Voyage',
    calls: Array<{
      __typename?: 'Call',
      id: number
    }>
  } | null
};

export type GetVoyagePlanQueryVariables = Types.Exact<{
  id: Types.Scalars['Long']['input'];
}>;


export type GetVoyagePlanQuery = {
  __typename?: 'Query',
  voyagePlan?: {
    __typename?: 'VoyagePlan',
    startTime?: number | null,
    durationMin?: number | null,
    distanceKm?: number | null,
    endTime?: number | null,
    totalWaitingTimeMin?: number | null,
    events?: Array<{
      __typename: 'BridgeEvent',
      name?: string | null,
      heightCm?: number | null,
      type: Types.VoyageEventType,
      latitude?: number | null,
      longitude?: number | null,
      startTime?: number | null,
      warning?: {
        __typename?: 'Warning',
        timestamp?: number | null,
        message?: string | null
      } | null
    } | {
      __typename: 'CallEvent',
      type: Types.VoyageEventType,
      latitude?: number | null,
      longitude?: number | null,
      startTime?: number | null,
      referable?: {
        __typename?: 'AnglerCall',
        id?: number | null,
        type?: Types.CallType | null,
        pta?: number | null,
        ptd?: number | null,
        eta?: number | null,
        etd?: number | null,
        ata?: number | null,
        atd?: number | null,
        systemAta?: number | null,
        systemAtd?: number | null,
        systemEta?: number | null,
        nrLoadingCargos?: number | null,
        nrDischargingCargos?: number | null,
        actualStatusCode?: number | null,
        loadedWeight?: number | null,
        dischargedWeight?: number | null,
        loadedTeuOnVoyageAfterCall?: number | null,
        loadedWeightOnVoyageAfterCall?: number | null,
        remainingTeuCapacity?: number | null,
        remainingWeightCapacity?: number | null,
        location?: {
          __typename?: 'AnglerLocation',
          id?: number | null,
          code?: string | null,
          description?: string | null,
          type?: Types.LocationType | null,
          telephone?: string | null,
          email?: string | null,
          position?: {
            __typename?: 'AnglerPosition',
            latitude?: number | null,
            longitude?: number | null
          } | null,
          address?: {
            __typename?: 'Address',
            town?: string | null
          } | null
        } | null,
        loadingCargos?: Array<{
          __typename?: 'AnglerCargo',
          id?: number | null,
          product?: {
            __typename?: 'AnglerProduct',
            id?: number | null,
            name?: string | null
          } | null,
          actions?: Array<{
            __typename?: 'AnglerCargoAction',
            id?: number | null,
            type?: Types.CallType | null,
            weight?: number | null,
            volume?: number | null,
            measurements?: {
              __typename?: 'AnglerMeasurements',
              locationVolumeL15?: number | null,
              locationWeightMTon?: number | null,
              skipperVolumeL15?: number | null,
              skipperVolumeM3?: number | null
            } | null
          } | null> | null
        } | null> | null,
        dischargingCargos?: Array<{
          __typename?: 'AnglerCargo',
          id?: number | null,
          product?: {
            __typename?: 'AnglerProduct',
            id?: number | null,
            name?: string | null
          } | null,
          actions?: Array<{
            __typename?: 'AnglerCargoAction',
            id?: number | null,
            type?: Types.CallType | null,
            weight?: number | null,
            volume?: number | null,
            measurements?: {
              __typename?: 'AnglerMeasurements',
              locationVolumeL15?: number | null,
              locationWeightMTon?: number | null,
              skipperVolumeL15?: number | null,
              skipperVolumeM3?: number | null
            } | null
          } | null> | null
        } | null> | null,
        numberOfLoadingContainers?: {
          __typename?: 'NumberOfContainers',
          numEmptyLessThanOrEqualTo20ft: number,
          numEmptyFrom21ftThrough30ft: number,
          numEmptyFrom31ftThrough40ft: number,
          numEmptyGreaterThan40ft: number,
          numFullLessThanOrEqualTo20ft: number,
          numFullFrom21ftThrough30ft: number,
          numFullFrom31ftThrough40ft: number,
          numFullGreaterThan40ft: number,
          numLessThanOrEqualTo20ft: number,
          numFrom21ftThrough30ft: number,
          numFrom31ftThrough40ft: number,
          numGreaterThan40ft: number,
          totalTeu: number,
          numTotalFullContainers: number,
          numTotalEmptyContainers: number,
          numTotalContainers: number
        } | null,
        numberOfDischargingContainers?: {
          __typename?: 'NumberOfContainers',
          numEmptyLessThanOrEqualTo20ft: number,
          numEmptyFrom21ftThrough30ft: number,
          numEmptyFrom31ftThrough40ft: number,
          numEmptyGreaterThan40ft: number,
          numFullLessThanOrEqualTo20ft: number,
          numFullFrom21ftThrough30ft: number,
          numFullFrom31ftThrough40ft: number,
          numFullGreaterThan40ft: number,
          numLessThanOrEqualTo20ft: number,
          numFrom21ftThrough30ft: number,
          numFrom31ftThrough40ft: number,
          numGreaterThan40ft: number,
          totalTeu: number,
          numTotalFullContainers: number,
          numTotalEmptyContainers: number,
          numTotalContainers: number
        } | null,
        numberOfLoadingReeferContainers?: {
          __typename?: 'NumberOfContainers',
          numEmptyLessThanOrEqualTo20ft: number,
          numEmptyFrom21ftThrough30ft: number,
          numEmptyFrom31ftThrough40ft: number,
          numEmptyGreaterThan40ft: number,
          numFullLessThanOrEqualTo20ft: number,
          numFullFrom21ftThrough30ft: number,
          numFullFrom31ftThrough40ft: number,
          numFullGreaterThan40ft: number,
          numLessThanOrEqualTo20ft: number,
          numFrom21ftThrough30ft: number,
          numFrom31ftThrough40ft: number,
          numGreaterThan40ft: number,
          totalTeu: number,
          numTotalFullContainers: number,
          numTotalEmptyContainers: number,
          numTotalContainers: number
        } | null,
        numberOfDischargingReeferContainers?: {
          __typename?: 'NumberOfContainers',
          numEmptyLessThanOrEqualTo20ft: number,
          numEmptyFrom21ftThrough30ft: number,
          numEmptyFrom31ftThrough40ft: number,
          numEmptyGreaterThan40ft: number,
          numFullLessThanOrEqualTo20ft: number,
          numFullFrom21ftThrough30ft: number,
          numFullFrom31ftThrough40ft: number,
          numFullGreaterThan40ft: number,
          numLessThanOrEqualTo20ft: number,
          numFrom21ftThrough30ft: number,
          numFrom31ftThrough40ft: number,
          numGreaterThan40ft: number,
          totalTeu: number,
          numTotalFullContainers: number,
          numTotalEmptyContainers: number,
          numTotalContainers: number
        } | null
      } | null,
      warning?: {
        __typename?: 'Warning',
        timestamp?: number | null,
        message?: string | null
      } | null
    } | {
      __typename: 'LockEvent',
      name?: string | null,
      status?: Types.LockStatus | null,
      lastUpdate?: number | null,
      type: Types.VoyageEventType,
      latitude?: number | null,
      longitude?: number | null,
      startTime?: number | null,
      warning?: {
        __typename?: 'Warning',
        timestamp?: number | null,
        message?: string | null
      } | null
    } | {
      __typename: 'LongDuringEvent',
      type: Types.VoyageEventType,
      latitude?: number | null,
      longitude?: number | null,
      startTime?: number | null,
      warning?: {
        __typename?: 'Warning',
        timestamp?: number | null,
        message?: string | null
      } | null
    } | {
      __typename: 'MeasuringPointEvent',
      name?: string | null,
      keelClearanceCm?: number | null,
      keelClearanceStatus?: Types.KeelClearanceStatus | null,
      type: Types.VoyageEventType,
      latitude?: number | null,
      longitude?: number | null,
      startTime?: number | null,
      measurement?: {
        __typename?: 'Measurement',
        waterLevel?: number | null,
        timestamp?: number | null,
        waterwayDepthCm?: number | null
      } | null,
      warning?: {
        __typename?: 'Warning',
        timestamp?: number | null,
        message?: string | null
      } | null
    } | {
      __typename: 'ShippingEvent',
      distanceKm?: number | null,
      durationMin?: number | null,
      type: Types.VoyageEventType,
      latitude?: number | null,
      longitude?: number | null,
      startTime?: number | null,
      warning?: {
        __typename?: 'Warning',
        timestamp?: number | null,
        message?: string | null
      } | null
    } | {
      __typename: 'StartPositionEvent',
      type: Types.VoyageEventType,
      latitude?: number | null,
      longitude?: number | null,
      startTime?: number | null,
      warning?: {
        __typename?: 'Warning',
        timestamp?: number | null,
        message?: string | null
      } | null
    } | {
      __typename: 'WaitingEvent',
      endTime?: number | null,
      type: Types.VoyageEventType,
      latitude?: number | null,
      longitude?: number | null,
      startTime?: number | null,
      warning?: {
        __typename?: 'Warning',
        timestamp?: number | null,
        message?: string | null
      } | null
    }> | null,
    lowestMeasuringPointDepth?: {
      __typename?: 'MeasuringPointEvent',
      id?: number | null,
      name?: string | null,
      requiredWaterwayDepthCm?: number | null,
      keelClearanceStatus?: Types.KeelClearanceStatus | null,
      keelClearanceCm?: number | null,
      measurement?: {
        __typename?: 'Measurement',
        timestamp?: number | null,
        waterLevel?: number | null,
        waterwayDepthCm?: number | null
      } | null
    } | null,
    lowestBridge?: {
      __typename?: 'BridgeEvent',
      id?: number | null,
      name?: string | null,
      heightCm?: number | null
    } | null
  } | null
};

export type GetVoyagePlanCompactQueryVariables = Types.Exact<{
  id: Types.Scalars['Long']['input'];
}>;


export type GetVoyagePlanCompactQuery = {
  __typename?: 'Query',
  voyagePlan?: {
    __typename?: 'VoyagePlan',
    durationMin?: number | null,
    distanceKm?: number | null,
    totalWaitingTimeMin?: number | null,
    startTime?: number | null,
    endTime?: number | null,
    lowestMeasuringPointDepth?: {
      __typename?: 'MeasuringPointEvent',
      name?: string | null,
      keelClearanceCm?: number | null,
      measurement?: {
        __typename?: 'Measurement',
        timestamp?: number | null,
        waterLevel?: number | null,
        waterwayDepthCm?: number | null
      } | null
    } | null
  } | null
};

export type GetReeferChecklistQueryVariables = Types.Exact<{
  voyageId: Types.Scalars['Long']['input'];
}>;


export type GetReeferChecklistQuery = {
  __typename?: 'Query',
  voyage?: {
    __typename?: 'Voyage',
    id: number,
    cargos: Array<{
      __typename?: 'Cargo',
      id: number,
      loaded?: number | null,
      loadingReference?: string | null,
      desiredTemperature?: number | null,
      containerNumber?: string | null,
      reeferCheckType?: Types.ReeferCheckType | null,
      containerType?: {
        __typename?: 'ContainerType',
        isoTypeCode: string,
        displayCode?: string | null
      } | null,
      firstLoadingAction?: {
        __typename?: 'CargoAction',
        id: number,
        start?: number | null,
        location?: {
          __typename?: 'Location',
          id: number,
          description: string,
          displayCode?: string | null,
          locationGroups: Array<{
            __typename?: 'Location',
            id: number,
            description: string,
            type: Types.LocationType
          }>
        } | null
      } | null,
      lastDischargingAction?: {
        __typename?: 'CargoAction',
        id: number,
        location?: {
          __typename?: 'Location',
          id: number,
          description: string,
          displayCode?: string | null,
          locationGroups: Array<{
            __typename?: 'Location',
            id: number,
            description: string,
            type: Types.LocationType
          }>
        } | null
      } | null,
      reeferChecklist?: {
        __typename?: 'ReeferCheckList',
        location?: string | null,
        setPoint?: number | null,
        plugin?: {
          __typename?: 'ReeferPlugin',
          id?: number | null,
          timestamp?: number | null,
          temperature?: number | null
        } | null,
        plugout?: {
          __typename?: 'ReeferPlugin',
          id?: number | null,
          timestamp?: number | null,
          temperature?: number | null
        } | null
      } | null
    }>
  } | null
};

export type GetVoyageReorderCallsQueryVariables = Types.Exact<{
  voyageId: Types.Scalars['Long']['input'];
}>;


export type GetVoyageReorderCallsQuery = {
  __typename?: 'Query',
  voyage?: {
    __typename?: 'Voyage',
    calls: Array<{
      __typename?: 'Call',
      id: number,
      pta?: number | null,
      simulatedTimestamp: boolean,
      location: {
        __typename?: 'Location',
        code?: string | null,
        id: number,
        description: string,
        type: Types.LocationType,
        locationGroups: Array<{
          __typename?: 'Location',
          type: Types.LocationType,
          id: number,
          description: string
        }>
      },
      lastStatusChange?: {
        __typename?: 'StatusChange',
        id: number,
        actualTime?: number | null,
        actualTimeOriginal?: number | null,
        actualTimeOverride?: number | null,
        estimateTime?: number | null,
        comment?: string | null,
        skipperComment?: string | null,
        timestamp?: number | null,
        appliedBy?: string | null,
        deletable: boolean,
        communicatedToCustomer?: number | null,
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          type: Types.StatusType,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }>,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null
        },
        supplier?: {
          __typename?: 'Relation',
          id: number,
          name: string
        } | null,
        origin?: {
          __typename?: 'StatusChange',
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }
        } | null
      } | null,
      cargos: Array<{
        __typename?: 'CargoAction',
        id: number,
        start?: number | null,
        end?: number | null,
        simulatedTimestamp?: boolean | null,
        type: Types.CallType,
        reference?: string | null,
        location?: {
          __typename?: 'Location',
          code?: string | null,
          id: number,
          description: string,
          type: Types.LocationType,
          locationGroups: Array<{
            __typename?: 'Location',
            type: Types.LocationType,
            id: number,
            description: string
          }>
        } | null,
        cargo: {
          __typename?: 'Cargo',
          id: number,
          cargoNumber?: string | null,
          product?: {
            __typename?: 'Product',
            id: number,
            name: string
          } | null
        }
      }>
    }>
  } | null
};

export type GetVoyageTimesheetStatusesQueryVariables = Types.Exact<{
  search: Types.StatusSearch;
}>;


export type GetVoyageTimesheetStatusesQuery = {
  __typename?: 'Query',
  allStatuses?: Array<{
    __typename?: 'Status',
    id: number,
    description: string,
    cargoActionType?: Types.CallType | null,
    statusOrder?: number | null,
    laytimeStartStatus: boolean,
    laytimeEndStatus: boolean,
    translations?: {
      __typename?: 'LanguageDescription',
      defaultValue?: string | null,
      descriptions: Array<{
        __typename?: 'TranslationKeyValuePair',
        key: string,
        value: string
      }>
    } | null
  }> | null
};

export type GetAssignableShipTanksQueryVariables = Types.Exact<{
  voyageId: Types.Scalars['Long']['input'];
  cargoId: Types.Scalars['Int']['input'];
  shipId: Types.Scalars['Long']['input'];
}>;


export type GetAssignableShipTanksQuery = {
  __typename?: 'Query',
  ship: {
    __typename?: 'Ship',
    id: number,
    name: string,
    tanks: Array<{
      __typename?: 'Tank',
      isAssignable?: boolean | null,
      id: number,
      position: Types.TankPosition,
      positionNumber: number,
      capacityM3?: number | null
    }>,
    tankProperties?: {
      __typename?: 'TankProperties',
      tankConfiguration: Types.TankConfiguration
    } | null
  }
};

export type GetActiveVoyageQueryVariables = Types.Exact<{
  shipId?: Types.InputMaybe<Types.Scalars['Long']['input']>;
}>;


export type GetActiveVoyageQuery = {
  __typename?: 'Query',
  activeVoyage?: {
    __typename?: 'Voyage',
    id: number,
    voyageNumber: string,
    inactivityType?: Types.InactivityType | null,
    isBallast: boolean,
    start?: number | null,
    end?: number | null,
    lastShippedProductsFreeText: Array<string>,
    sailingReport?: {
      __typename?: 'SailingReport',
      id: number
    } | null,
    ship: {
      __typename?: 'Ship',
      bargeType?: Types.BargeType | null,
      id: number,
      name: string,
      operator?: {
        __typename?: 'Relation',
        id: number,
        name: string,
        isApplicationRelation?: boolean | null
      } | null
    },
    calls: Array<{
      __typename?: 'Call',
      id: number,
      expectedLoadingAmount?: number | null,
      expectedDischargingAmount?: number | null,
      expectedLoadingTeu?: number | null,
      expectedDischargingTeu?: number | null,
      nrLoadingCargos: number,
      nrDischargingCargos: number,
      callLoadingTeu?: number | null,
      callDischargingTeu?: number | null,
      simulatedTimestamp: boolean,
      pta?: number | null,
      ptd?: number | null,
      ata?: number | null,
      atd?: number | null,
      eta?: number | null,
      etd?: number | null,
      loadedWeight?: number | null,
      dischargedWeight?: number | null,
      etso?: number | null,
      eteo?: number | null,
      atso?: number | null,
      ateo?: number | null,
      etfm?: number | null,
      etlm?: number | null,
      atfm?: number | null,
      atlm?: number | null,
      atn?: number | null,
      dtn?: number | null,
      systemAta?: number | null,
      systemAtd?: number | null,
      systemEta?: number | null,
      systemEtd?: number | null,
      cargos: Array<{
        __typename?: 'CargoAction',
        start?: number | null,
        end?: number | null,
        displayAsWindow?: boolean | null,
        id: number,
        type: Types.CallType,
        timesheetNote?: string | null,
        simulatedTimestamp?: boolean | null,
        weight?: number | null,
        volume?: number | null,
        limitType?: Types.LimitType | null,
        limitValue?: number | null,
        notes?: string | null,
        reference?: string | null,
        shipToShip?: boolean | null,
        connectingVisitNotes?: string | null,
        location?: {
          __typename?: 'Location',
          displayCode?: string | null,
          code?: string | null,
          notes?: string | null,
          uabRegistration?: boolean | null,
          id: number,
          description: string,
          type: Types.LocationType,
          contacts?: Array<{
            __typename?: 'Contact',
            id: number,
            name?: string | null,
            telephone?: string | null
          }> | null,
          locationGroups: Array<{
            __typename?: 'Location',
            code?: string | null,
            id: number,
            description: string,
            type: Types.LocationType
          }>
        } | null,
        cargo: {
          __typename?: 'Cargo',
          id: number,
          cargoNumber?: string | null,
          containerNumber?: string | null,
          weight?: number | null,
          volume?: number | null,
          isWeightPrimary: boolean,
          isVolumePrimary: boolean,
          waterLevelOptimised: boolean,
          weightToleranceType?: Types.WeightToleranceType | null,
          weightOptionType?: Types.WeightOptionType | null,
          weightOptionPercentage?: number | null,
          declaredFinalWeight?: number | null,
          isHoseRentalRequired: boolean,
          isInhibitedProduct: boolean,
          isNitrogenBlanketingRequired: boolean,
          isNitrogenPurgingRequired: boolean,
          isTemperatureControlRequired: boolean,
          isCleaningRequired: boolean,
          loadingReference?: string | null,
          dischargingReference?: string | null,
          lastStatusChange?: {
            __typename?: 'StatusChange',
            id: number,
            actualTime?: number | null,
            actualTimeOriginal?: number | null,
            actualTimeOverride?: number | null,
            estimateTime?: number | null,
            comment?: string | null,
            skipperComment?: string | null,
            timestamp?: number | null,
            appliedBy?: string | null,
            deletable: boolean,
            communicatedToCustomer?: number | null,
            status: {
              __typename?: 'Status',
              id: number,
              statusOrder?: number | null,
              cargoActionType?: Types.CallType | null,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              description: string,
              type: Types.StatusType,
              color: string,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean,
                cargoActionType?: Types.CallType | null,
                color: string,
                statusOrder?: number | null,
                supplierRequired: boolean,
                skipperRequiredFillInSailingReport: boolean,
                skipperRequiredFillInWeightVolume: boolean,
                requireActualTime: Types.StatusActualTimeType,
                estimateType?: Types.StatusEstimateType | null,
                estimateRequirement: Types.StatusEstimateRequirement,
                shouldLoadOnTerminal: boolean,
                closedStatus: boolean,
                cancelledStatus: boolean,
                loadedStatus: boolean,
                dischargedStatus: boolean,
                finishedStatus: boolean,
                allowComment: boolean,
                allowSkipperComment: boolean,
                shouldUpdateJDE: boolean,
                isInProgress: boolean,
                voyageVisibleBySkipper: boolean,
                voyageVisibleByCreditor: boolean,
                voyageEditableBySkipper: boolean,
                voyageEditableByCreditor: boolean,
                callVisibleByLocationOwner: boolean,
                isRejectStatus: boolean,
                isAcceptStatus: boolean,
                notifySkippers: boolean,
                notifyShipManagers: boolean,
                notifyShipOwners: boolean,
                notifyOperators: boolean,
                notifyCustomers: boolean,
                notifyTerminals: boolean,
                isCustomerNominatingStatus: boolean,
                isSkipperNominatingStatus: boolean,
                includeInNominationExport: boolean,
                laytimeStartStatus: boolean,
                laytimeEndStatus: boolean,
                requireDocuments: boolean,
                showConfirmMessage: boolean,
                expiringStatus: boolean,
                isActionStatus: boolean,
                requireTanks: boolean,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean,
                  type?: Types.SendDocumentType | null,
                  target?: Types.DocumentTarget | null
                } | null,
                translations?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                confirmMessages?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                rules?: Array<{
                  __typename?: 'Rule',
                  id: number,
                  ifFitsStatusFlow: boolean,
                  ifNotAppliedBefore: boolean,
                  ruleType: {
                    __typename?: 'RuleType',
                    name: Types.StatusRule
                  },
                  targetStatus: {
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    supplierRequired: boolean,
                    description: string,
                    sendDocument?: {
                      __typename?: 'SendDocumentStatus',
                      enabled: boolean
                    } | null
                  }
                }> | null,
                successiveStatuses: Array<{
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  description: string,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean
                }>
              }>,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null
            },
            supplier?: {
              __typename?: 'Relation',
              id: number,
              name: string
            } | null,
            origin?: {
              __typename?: 'StatusChange',
              status: {
                __typename?: 'Status',
                id: number,
                description: string,
                type: Types.StatusType,
                cargoActionType?: Types.CallType | null,
                color: string,
                statusOrder?: number | null,
                supplierRequired: boolean,
                skipperRequiredFillInSailingReport: boolean,
                skipperRequiredFillInWeightVolume: boolean,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean,
                requireActualTime: Types.StatusActualTimeType,
                estimateType?: Types.StatusEstimateType | null,
                estimateRequirement: Types.StatusEstimateRequirement,
                shouldLoadOnTerminal: boolean,
                closedStatus: boolean,
                cancelledStatus: boolean,
                loadedStatus: boolean,
                dischargedStatus: boolean,
                finishedStatus: boolean,
                allowComment: boolean,
                allowSkipperComment: boolean,
                shouldUpdateJDE: boolean,
                isInProgress: boolean,
                voyageVisibleBySkipper: boolean,
                voyageVisibleByCreditor: boolean,
                voyageEditableBySkipper: boolean,
                voyageEditableByCreditor: boolean,
                callVisibleByLocationOwner: boolean,
                isRejectStatus: boolean,
                isAcceptStatus: boolean,
                notifySkippers: boolean,
                notifyShipManagers: boolean,
                notifyShipOwners: boolean,
                notifyOperators: boolean,
                notifyCustomers: boolean,
                notifyTerminals: boolean,
                isCustomerNominatingStatus: boolean,
                isSkipperNominatingStatus: boolean,
                includeInNominationExport: boolean,
                laytimeStartStatus: boolean,
                laytimeEndStatus: boolean,
                requireDocuments: boolean,
                showConfirmMessage: boolean,
                expiringStatus: boolean,
                isActionStatus: boolean,
                requireTanks: boolean,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean,
                  type?: Types.SendDocumentType | null,
                  target?: Types.DocumentTarget | null
                } | null,
                translations?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                confirmMessages?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                rules?: Array<{
                  __typename?: 'Rule',
                  id: number,
                  ifFitsStatusFlow: boolean,
                  ifNotAppliedBefore: boolean,
                  ruleType: {
                    __typename?: 'RuleType',
                    name: Types.StatusRule
                  },
                  targetStatus: {
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    supplierRequired: boolean,
                    description: string,
                    sendDocument?: {
                      __typename?: 'SendDocumentStatus',
                      enabled: boolean
                    } | null
                  }
                }> | null,
                successiveStatuses: Array<{
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  description: string,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean
                }>
              }
            } | null
          } | null,
          statusChanges: Array<{
            __typename?: 'StatusChange',
            id: number,
            actualTime?: number | null,
            actualTimeOriginal?: number | null,
            actualTimeOverride?: number | null,
            estimateTime?: number | null,
            comment?: string | null,
            skipperComment?: string | null,
            timestamp?: number | null,
            appliedBy?: string | null,
            deletable: boolean,
            communicatedToCustomer?: number | null,
            status: {
              __typename?: 'Status',
              id: number,
              statusOrder?: number | null,
              cargoActionType?: Types.CallType | null,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              description: string,
              type: Types.StatusType,
              color: string,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean,
                cargoActionType?: Types.CallType | null,
                color: string,
                statusOrder?: number | null,
                supplierRequired: boolean,
                skipperRequiredFillInSailingReport: boolean,
                skipperRequiredFillInWeightVolume: boolean,
                requireActualTime: Types.StatusActualTimeType,
                estimateType?: Types.StatusEstimateType | null,
                estimateRequirement: Types.StatusEstimateRequirement,
                shouldLoadOnTerminal: boolean,
                closedStatus: boolean,
                cancelledStatus: boolean,
                loadedStatus: boolean,
                dischargedStatus: boolean,
                finishedStatus: boolean,
                allowComment: boolean,
                allowSkipperComment: boolean,
                shouldUpdateJDE: boolean,
                isInProgress: boolean,
                voyageVisibleBySkipper: boolean,
                voyageVisibleByCreditor: boolean,
                voyageEditableBySkipper: boolean,
                voyageEditableByCreditor: boolean,
                callVisibleByLocationOwner: boolean,
                isRejectStatus: boolean,
                isAcceptStatus: boolean,
                notifySkippers: boolean,
                notifyShipManagers: boolean,
                notifyShipOwners: boolean,
                notifyOperators: boolean,
                notifyCustomers: boolean,
                notifyTerminals: boolean,
                isCustomerNominatingStatus: boolean,
                isSkipperNominatingStatus: boolean,
                includeInNominationExport: boolean,
                laytimeStartStatus: boolean,
                laytimeEndStatus: boolean,
                requireDocuments: boolean,
                showConfirmMessage: boolean,
                expiringStatus: boolean,
                isActionStatus: boolean,
                requireTanks: boolean,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean,
                  type?: Types.SendDocumentType | null,
                  target?: Types.DocumentTarget | null
                } | null,
                translations?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                confirmMessages?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                rules?: Array<{
                  __typename?: 'Rule',
                  id: number,
                  ifFitsStatusFlow: boolean,
                  ifNotAppliedBefore: boolean,
                  ruleType: {
                    __typename?: 'RuleType',
                    name: Types.StatusRule
                  },
                  targetStatus: {
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    supplierRequired: boolean,
                    description: string,
                    sendDocument?: {
                      __typename?: 'SendDocumentStatus',
                      enabled: boolean
                    } | null
                  }
                }> | null,
                successiveStatuses: Array<{
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  description: string,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean
                }>
              }>,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null
            },
            supplier?: {
              __typename?: 'Relation',
              id: number,
              name: string
            } | null,
            origin?: {
              __typename?: 'StatusChange',
              status: {
                __typename?: 'Status',
                id: number,
                description: string,
                type: Types.StatusType,
                cargoActionType?: Types.CallType | null,
                color: string,
                statusOrder?: number | null,
                supplierRequired: boolean,
                skipperRequiredFillInSailingReport: boolean,
                skipperRequiredFillInWeightVolume: boolean,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean,
                requireActualTime: Types.StatusActualTimeType,
                estimateType?: Types.StatusEstimateType | null,
                estimateRequirement: Types.StatusEstimateRequirement,
                shouldLoadOnTerminal: boolean,
                closedStatus: boolean,
                cancelledStatus: boolean,
                loadedStatus: boolean,
                dischargedStatus: boolean,
                finishedStatus: boolean,
                allowComment: boolean,
                allowSkipperComment: boolean,
                shouldUpdateJDE: boolean,
                isInProgress: boolean,
                voyageVisibleBySkipper: boolean,
                voyageVisibleByCreditor: boolean,
                voyageEditableBySkipper: boolean,
                voyageEditableByCreditor: boolean,
                callVisibleByLocationOwner: boolean,
                isRejectStatus: boolean,
                isAcceptStatus: boolean,
                notifySkippers: boolean,
                notifyShipManagers: boolean,
                notifyShipOwners: boolean,
                notifyOperators: boolean,
                notifyCustomers: boolean,
                notifyTerminals: boolean,
                isCustomerNominatingStatus: boolean,
                isSkipperNominatingStatus: boolean,
                includeInNominationExport: boolean,
                laytimeStartStatus: boolean,
                laytimeEndStatus: boolean,
                requireDocuments: boolean,
                showConfirmMessage: boolean,
                expiringStatus: boolean,
                isActionStatus: boolean,
                requireTanks: boolean,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean,
                  type?: Types.SendDocumentType | null,
                  target?: Types.DocumentTarget | null
                } | null,
                translations?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                confirmMessages?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                rules?: Array<{
                  __typename?: 'Rule',
                  id: number,
                  ifFitsStatusFlow: boolean,
                  ifNotAppliedBefore: boolean,
                  ruleType: {
                    __typename?: 'RuleType',
                    name: Types.StatusRule
                  },
                  targetStatus: {
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    supplierRequired: boolean,
                    description: string,
                    sendDocument?: {
                      __typename?: 'SendDocumentStatus',
                      enabled: boolean
                    } | null
                  }
                }> | null,
                successiveStatuses: Array<{
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  description: string,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean
                }>
              }
            } | null
          }>,
          charter?: {
            __typename?: 'SalesCharter',
            id: number,
            charterNumber: string,
            type: Types.CharterType,
            purchaseCharter?: {
              __typename?: 'PurchaseCharter',
              id: number,
              customerReference?: string | null
            } | null
          } | null,
          product?: {
            __typename?: 'Product',
            id: number,
            name: string,
            description?: string | null,
            productInstructionsForVessel?: string | null,
            heatingInstructionsForVessel?: string | null,
            isDangerousGood?: boolean | null,
            documents?: Array<{
              __typename?: 'Document',
              id: number,
              documentType?: string | null,
              type: string,
              active?: boolean | null
            }> | null
          } | null,
          customerTransportDocument?: {
            __typename?: 'Document',
            id: number
          } | null,
          supplier?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          consignor?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          consignee?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          tanks: Array<{
            __typename?: 'Tank',
            id: number,
            position: Types.TankPosition,
            positionNumber: number,
            capacityM3?: number | null
          }>
        },
        documents: Array<{
          __typename?: 'Document',
          documentEntity: Types.DocumentEntity
        }>,
        surveyor?: {
          __typename?: 'Relation',
          id: number,
          name: string,
          contacts: Array<{
            __typename?: 'Contact',
            id: number,
            name?: string | null,
            telephone?: string | null
          }>
        } | null,
        connectingShipPortVisit?: {
          __typename?: 'ConnectingShipPortVisit',
          id: number,
          from?: number | null,
          until?: number | null,
          lastUpdateFromAgentOn?: number | null,
          ship: {
            __typename?: 'Ship',
            id: number,
            name: string,
            planningNotes?: string | null
          },
          location: {
            __typename?: 'Location',
            id: number,
            description: string,
            type: Types.LocationType
          },
          agent?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          connectingShipBerthings?: Array<{
            __typename?: 'ConnectingShipBerthing',
            id?: number | null,
            location?: {
              __typename?: 'Location',
              id: number,
              description: string,
              type: Types.LocationType
            } | null,
            window?: {
              __typename?: 'TimeWindow',
              from?: number | null,
              to?: number | null
            } | null
          }> | null
        } | null,
        connectingShipBerthing?: {
          __typename?: 'ConnectingShipBerthing',
          id?: number | null,
          location?: {
            __typename?: 'Location',
            id: number,
            description: string,
            type: Types.LocationType
          } | null,
          window?: {
            __typename?: 'TimeWindow',
            from?: number | null,
            to?: number | null
          } | null
        } | null,
        measurements: {
          __typename?: 'Measurements',
          locationWeight?: number | null,
          locationWeightUnit?: Types.WeightUnit | null,
          skipperWeight?: number | null,
          skipperWeightUnit?: Types.WeightUnit | null,
          locationVolume?: number | null,
          locationVolumeUnit?: Types.VolumeUnit | null,
          skipperVolume?: number | null,
          skipperVolumeUnit?: Types.VolumeUnit | null,
          ambientVolume?: number | null,
          relativeDensity?: number | null,
          productTemperature?: number | null,
          actualConsignor?: string | null,
          actualConsignee?: string | null,
          protest?: boolean | null
        }
      }>,
      location: {
        __typename?: 'Location',
        type: Types.LocationType,
        id: number,
        description: string,
        locationGroups: Array<{
          __typename?: 'Location',
          code?: string | null,
          id: number,
          description: string,
          type: Types.LocationType
        }>
      },
      lastStatusChange?: {
        __typename?: 'StatusChange',
        id: number,
        actualTime?: number | null,
        actualTimeOriginal?: number | null,
        actualTimeOverride?: number | null,
        estimateTime?: number | null,
        comment?: string | null,
        skipperComment?: string | null,
        timestamp?: number | null,
        appliedBy?: string | null,
        deletable: boolean,
        communicatedToCustomer?: number | null,
        status: {
          __typename?: 'Status',
          id: number,
          statusOrder?: number | null,
          cargoActionType?: Types.CallType | null,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          description: string,
          type: Types.StatusType,
          color: string,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }>,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null
        },
        supplier?: {
          __typename?: 'Relation',
          id: number,
          name: string
        } | null,
        origin?: {
          __typename?: 'StatusChange',
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }
        } | null
      } | null,
      statusChanges: Array<{
        __typename?: 'StatusChange',
        id: number,
        actualTime?: number | null,
        actualTimeOriginal?: number | null,
        actualTimeOverride?: number | null,
        estimateTime?: number | null,
        comment?: string | null,
        skipperComment?: string | null,
        timestamp?: number | null,
        appliedBy?: string | null,
        deletable: boolean,
        communicatedToCustomer?: number | null,
        status: {
          __typename?: 'Status',
          id: number,
          statusOrder?: number | null,
          cargoActionType?: Types.CallType | null,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          description: string,
          type: Types.StatusType,
          color: string,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }>,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null
        },
        supplier?: {
          __typename?: 'Relation',
          id: number,
          name: string
        } | null,
        origin?: {
          __typename?: 'StatusChange',
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }
        } | null
      }>,
      expectedCargos: Array<{
        __typename?: 'ExpectedCargo',
        id: number,
        actionType: Types.CallType,
        amount: number,
        full: boolean,
        dischargingLocation?: {
          __typename?: 'Location',
          id: number,
          description: string,
          type: Types.LocationType,
          locationGroups: Array<{
            __typename?: 'Location',
            code?: string | null,
            id: number,
            description: string,
            type: Types.LocationType
          }>
        } | null,
        containerType: {
          __typename?: 'ContainerType',
          isoTypeCode: string,
          teu: number
        }
      }>
    }>,
    purchaseCharters?: Array<{
      __typename?: 'PurchaseCharter',
      id: number,
      charterNumber: string,
      type: Types.CharterType,
      subtype: Types.CharterSubtype
    }> | null,
    scopeIn?: {
      __typename?: 'Scope',
      desired?: number | null,
      planned?: number | null,
      actual?: number | null,
      systemActual?: number | null,
      expected?: number | null,
      systemExpected?: number | null,
      expectedLocation?: {
        __typename?: 'Location',
        id: number,
        description: string,
        locationGroups: Array<{
          __typename?: 'Location',
          type: Types.LocationType,
          description: string
        }>
      } | null,
      plannedLocation?: {
        __typename?: 'Location',
        id: number,
        description: string,
        locationGroups: Array<{
          __typename?: 'Location',
          type: Types.LocationType,
          description: string
        }>
      } | null,
      actualLocation?: {
        __typename?: 'Location',
        id: number,
        description: string,
        locationGroups: Array<{
          __typename?: 'Location',
          type: Types.LocationType,
          description: string
        }>
      } | null
    } | null,
    scopeOut?: {
      __typename?: 'Scope',
      desired?: number | null,
      planned?: number | null,
      actual?: number | null,
      systemActual?: number | null,
      expected?: number | null,
      systemExpected?: number | null,
      expectedLocation?: {
        __typename?: 'Location',
        id: number,
        description: string
      } | null,
      plannedLocation?: {
        __typename?: 'Location',
        id: number,
        description: string
      } | null,
      actualLocation?: {
        __typename?: 'Location',
        id: number,
        description: string
      } | null
    } | null,
    cargos: Array<{
      __typename?: 'Cargo',
      id: number,
      cargoNumber?: string | null,
      containerNumber?: string | null,
      product?: {
        __typename?: 'Product',
        name: string
      } | null
    }>,
    creditor?: {
      __typename?: 'Relation',
      id: number,
      name: string
    } | null,
    cargoCharter?: {
      __typename?: 'SalesCharter',
      id: number,
      charterNumber: string,
      type: Types.CharterType
    } | null,
    schedule?: {
      __typename?: 'SailingSchedule',
      id: number,
      schedule: string
    } | null,
    lastStatusChange?: {
      __typename?: 'StatusChange',
      id: number,
      actualTime?: number | null,
      actualTimeOriginal?: number | null,
      actualTimeOverride?: number | null,
      estimateTime?: number | null,
      comment?: string | null,
      skipperComment?: string | null,
      timestamp?: number | null,
      appliedBy?: string | null,
      deletable: boolean,
      communicatedToCustomer?: number | null,
      status: {
        __typename?: 'Status',
        id: number,
        description: string,
        type: Types.StatusType,
        cargoActionType?: Types.CallType | null,
        color: string,
        statusOrder?: number | null,
        supplierRequired: boolean,
        skipperRequiredFillInSailingReport: boolean,
        skipperRequiredFillInWeightVolume: boolean,
        applyByCustomer: boolean,
        applyBySkipper: boolean,
        applyByTerminal: boolean,
        requireActualTime: Types.StatusActualTimeType,
        estimateType?: Types.StatusEstimateType | null,
        estimateRequirement: Types.StatusEstimateRequirement,
        shouldLoadOnTerminal: boolean,
        closedStatus: boolean,
        cancelledStatus: boolean,
        loadedStatus: boolean,
        dischargedStatus: boolean,
        finishedStatus: boolean,
        allowComment: boolean,
        allowSkipperComment: boolean,
        shouldUpdateJDE: boolean,
        isInProgress: boolean,
        voyageVisibleBySkipper: boolean,
        voyageVisibleByCreditor: boolean,
        voyageEditableBySkipper: boolean,
        voyageEditableByCreditor: boolean,
        callVisibleByLocationOwner: boolean,
        isRejectStatus: boolean,
        isAcceptStatus: boolean,
        notifySkippers: boolean,
        notifyShipManagers: boolean,
        notifyShipOwners: boolean,
        notifyOperators: boolean,
        notifyCustomers: boolean,
        notifyTerminals: boolean,
        isCustomerNominatingStatus: boolean,
        isSkipperNominatingStatus: boolean,
        includeInNominationExport: boolean,
        laytimeStartStatus: boolean,
        laytimeEndStatus: boolean,
        requireDocuments: boolean,
        showConfirmMessage: boolean,
        expiringStatus: boolean,
        isActionStatus: boolean,
        requireTanks: boolean,
        successiveStatuses: Array<{
          __typename?: 'Status',
          id: number,
          type: Types.StatusType,
          description: string,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }>,
        sendDocument?: {
          __typename?: 'SendDocumentStatus',
          enabled: boolean,
          type?: Types.SendDocumentType | null,
          target?: Types.DocumentTarget | null
        } | null,
        translations?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        confirmMessages?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        rules?: Array<{
          __typename?: 'Rule',
          id: number,
          ifFitsStatusFlow: boolean,
          ifNotAppliedBefore: boolean,
          ruleType: {
            __typename?: 'RuleType',
            name: Types.StatusRule
          },
          targetStatus: {
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            supplierRequired: boolean,
            description: string,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean
            } | null
          }
        }> | null
      },
      supplier?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      origin?: {
        __typename?: 'StatusChange',
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          type: Types.StatusType,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }
      } | null
    } | null,
    statusChanges: Array<{
      __typename?: 'StatusChange',
      id: number,
      actualTime?: number | null,
      actualTimeOriginal?: number | null,
      actualTimeOverride?: number | null,
      estimateTime?: number | null,
      comment?: string | null,
      skipperComment?: string | null,
      timestamp?: number | null,
      appliedBy?: string | null,
      deletable: boolean,
      communicatedToCustomer?: number | null,
      status: {
        __typename?: 'Status',
        id: number,
        description: string,
        type: Types.StatusType,
        cargoActionType?: Types.CallType | null,
        color: string,
        statusOrder?: number | null,
        supplierRequired: boolean,
        skipperRequiredFillInSailingReport: boolean,
        skipperRequiredFillInWeightVolume: boolean,
        applyByCustomer: boolean,
        applyBySkipper: boolean,
        applyByTerminal: boolean,
        requireActualTime: Types.StatusActualTimeType,
        estimateType?: Types.StatusEstimateType | null,
        estimateRequirement: Types.StatusEstimateRequirement,
        shouldLoadOnTerminal: boolean,
        closedStatus: boolean,
        cancelledStatus: boolean,
        loadedStatus: boolean,
        dischargedStatus: boolean,
        finishedStatus: boolean,
        allowComment: boolean,
        allowSkipperComment: boolean,
        shouldUpdateJDE: boolean,
        isInProgress: boolean,
        voyageVisibleBySkipper: boolean,
        voyageVisibleByCreditor: boolean,
        voyageEditableBySkipper: boolean,
        voyageEditableByCreditor: boolean,
        callVisibleByLocationOwner: boolean,
        isRejectStatus: boolean,
        isAcceptStatus: boolean,
        notifySkippers: boolean,
        notifyShipManagers: boolean,
        notifyShipOwners: boolean,
        notifyOperators: boolean,
        notifyCustomers: boolean,
        notifyTerminals: boolean,
        isCustomerNominatingStatus: boolean,
        isSkipperNominatingStatus: boolean,
        includeInNominationExport: boolean,
        laytimeStartStatus: boolean,
        laytimeEndStatus: boolean,
        requireDocuments: boolean,
        showConfirmMessage: boolean,
        expiringStatus: boolean,
        isActionStatus: boolean,
        requireTanks: boolean,
        successiveStatuses: Array<{
          __typename?: 'Status',
          id: number,
          type: Types.StatusType,
          description: string,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }>,
        sendDocument?: {
          __typename?: 'SendDocumentStatus',
          enabled: boolean,
          type?: Types.SendDocumentType | null,
          target?: Types.DocumentTarget | null
        } | null,
        translations?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        confirmMessages?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        rules?: Array<{
          __typename?: 'Rule',
          id: number,
          ifFitsStatusFlow: boolean,
          ifNotAppliedBefore: boolean,
          ruleType: {
            __typename?: 'RuleType',
            name: Types.StatusRule
          },
          targetStatus: {
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            supplierRequired: boolean,
            description: string,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean
            } | null
          }
        }> | null
      },
      supplier?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      origin?: {
        __typename?: 'StatusChange',
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          type: Types.StatusType,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }
      } | null
    }>,
    from?: {
      __typename?: 'Location',
      type: Types.LocationType,
      id: number,
      description: string
    } | null,
    to?: {
      __typename?: 'Location',
      type: Types.LocationType,
      id: number,
      description: string
    } | null
  } | null
};


export const GetVoyagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVoyages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VoyageSearchObject"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeCargos"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voyages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalElements"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UseVoyageTableFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UseVoyageTableFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Voyage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voyageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"externalVoyageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"allSuppliersConfigured"}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bargeType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"operator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isApplicationRelation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fleets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"purchaseCharters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"subtype"}},{"kind":"Field","name":{"kind":"Name","value":"customerReference"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"creditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"customerNumber"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"to"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"calls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"displayCode"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pta"}},{"kind":"Field","name":{"kind":"Name","value":"ptd"}},{"kind":"Field","name":{"kind":"Name","value":"eta"}},{"kind":"Field","name":{"kind":"Name","value":"systemEta"}},{"kind":"Field","name":{"kind":"Name","value":"etd"}},{"kind":"Field","name":{"kind":"Name","value":"ata"}},{"kind":"Field","name":{"kind":"Name","value":"systemAta"}},{"kind":"Field","name":{"kind":"Name","value":"atd"}},{"kind":"Field","name":{"kind":"Name","value":"systemAtd"}},{"kind":"Field","name":{"kind":"Name","value":"actualStatusCode"}},{"kind":"Field","name":{"kind":"Name","value":"simulatedTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"linkedChildCalls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voyage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"voyageNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"weight"}}]}},{"kind":"Field","name":{"kind":"Name","value":"voyage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bargeType"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceableWeek"}},{"kind":"Field","name":{"kind":"Name","value":"creditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scopeIn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"desired"}},{"kind":"Field","name":{"kind":"Name","value":"planned"}},{"kind":"Field","name":{"kind":"Name","value":"expected"}},{"kind":"Field","name":{"kind":"Name","value":"systemExpected"}},{"kind":"Field","name":{"kind":"Name","value":"actual"}},{"kind":"Field","name":{"kind":"Name","value":"systemActual"}},{"kind":"Field","name":{"kind":"Name","value":"expectedLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plannedLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actualLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scopeOut"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"desired"}},{"kind":"Field","name":{"kind":"Name","value":"planned"}},{"kind":"Field","name":{"kind":"Name","value":"expected"}},{"kind":"Field","name":{"kind":"Name","value":"systemExpected"}},{"kind":"Field","name":{"kind":"Name","value":"actual"}},{"kind":"Field","name":{"kind":"Name","value":"systemActual"}},{"kind":"Field","name":{"kind":"Name","value":"expectedLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plannedLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actualLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"isBallast"}},{"kind":"Field","name":{"kind":"Name","value":"actualWeightFilledIn"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeFilledIn"}},{"kind":"Field","name":{"kind":"Name","value":"cargoCharters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"debtor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"actualStart"}},{"kind":"Field","name":{"kind":"Name","value":"actualEnd"}},{"kind":"Field","name":{"kind":"Name","value":"sailingReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargos"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeCargos"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productDetails"}},{"kind":"Field","name":{"kind":"Name","value":"cargoNumber"}},{"kind":"Field","name":{"kind":"Name","value":"containerNumber"}},{"kind":"Field","name":{"kind":"Name","value":"loadingReference"}},{"kind":"Field","name":{"kind":"Name","value":"dischargingReference"}},{"kind":"Field","name":{"kind":"Name","value":"isWeightPrimary"}},{"kind":"Field","name":{"kind":"Name","value":"isVolumePrimary"}},{"kind":"Field","name":{"kind":"Name","value":"waterLevelOptimised"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusChangeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StatusChange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actualTime"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOriginal"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOverride"}},{"kind":"Field","name":{"kind":"Name","value":"estimateTime"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"skipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"appliedBy"}},{"kind":"Field","name":{"kind":"Name","value":"deletable"}},{"kind":"Field","name":{"kind":"Name","value":"communicatedToCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cargoActionType"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"target"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusOrder"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ruleType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ifFitsStatusFlow"}},{"kind":"Field","name":{"kind":"Name","value":"ifNotAppliedBefore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInSailingReport"}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInWeightVolume"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"requireActualTime"}},{"kind":"Field","name":{"kind":"Name","value":"estimateType"}},{"kind":"Field","name":{"kind":"Name","value":"estimateRequirement"}},{"kind":"Field","name":{"kind":"Name","value":"shouldLoadOnTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"closedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledStatus"}},{"kind":"Field","name":{"kind":"Name","value":"loadedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dischargedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"finishedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"allowComment"}},{"kind":"Field","name":{"kind":"Name","value":"allowSkipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"shouldUpdateJDE"}},{"kind":"Field","name":{"kind":"Name","value":"isInProgress"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"callVisibleByLocationOwner"}},{"kind":"Field","name":{"kind":"Name","value":"isRejectStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isAcceptStatus"}},{"kind":"Field","name":{"kind":"Name","value":"notifySkippers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipManagers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipOwners"}},{"kind":"Field","name":{"kind":"Name","value":"notifyOperators"}},{"kind":"Field","name":{"kind":"Name","value":"notifyCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyTerminals"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomerNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isSkipperNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeInNominationExport"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeStartStatus"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeEndStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireDocuments"}},{"kind":"Field","name":{"kind":"Name","value":"showConfirmMessage"}},{"kind":"Field","name":{"kind":"Name","value":"expiringStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isActionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireTanks"}}]}}]} as unknown as DocumentNode<GetVoyagesQuery, GetVoyagesQueryVariables>;
export const GetVoyageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVoyage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voyage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageInfo"}},{"kind":"Field","name":{"kind":"Name","value":"sailingReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"creditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"applicationRelation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"debtor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"applicationRelation"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"calls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"encodedPolyline"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"displayAsWindow"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusChangeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StatusChange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actualTime"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOriginal"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOverride"}},{"kind":"Field","name":{"kind":"Name","value":"estimateTime"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"skipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"appliedBy"}},{"kind":"Field","name":{"kind":"Name","value":"deletable"}},{"kind":"Field","name":{"kind":"Name","value":"communicatedToCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cargoActionType"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"target"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusOrder"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ruleType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ifFitsStatusFlow"}},{"kind":"Field","name":{"kind":"Name","value":"ifNotAppliedBefore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInSailingReport"}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInWeightVolume"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"requireActualTime"}},{"kind":"Field","name":{"kind":"Name","value":"estimateType"}},{"kind":"Field","name":{"kind":"Name","value":"estimateRequirement"}},{"kind":"Field","name":{"kind":"Name","value":"shouldLoadOnTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"closedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledStatus"}},{"kind":"Field","name":{"kind":"Name","value":"loadedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dischargedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"finishedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"allowComment"}},{"kind":"Field","name":{"kind":"Name","value":"allowSkipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"shouldUpdateJDE"}},{"kind":"Field","name":{"kind":"Name","value":"isInProgress"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"callVisibleByLocationOwner"}},{"kind":"Field","name":{"kind":"Name","value":"isRejectStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isAcceptStatus"}},{"kind":"Field","name":{"kind":"Name","value":"notifySkippers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipManagers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipOwners"}},{"kind":"Field","name":{"kind":"Name","value":"notifyOperators"}},{"kind":"Field","name":{"kind":"Name","value":"notifyCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyTerminals"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomerNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isSkipperNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeInNominationExport"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeStartStatus"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeEndStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireDocuments"}},{"kind":"Field","name":{"kind":"Name","value":"showConfirmMessage"}},{"kind":"Field","name":{"kind":"Name","value":"expiringStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isActionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireTanks"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Voyage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageDetailsTab"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyagePurchaseCharterTab"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageScopeTab"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageDocumentsVoyage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageDetailsTab"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Voyage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageSummaryVoyage"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageCallListVoyage"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageCargoActionDetailsVoyage"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageDocumentsVoyage"}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bargeType"}},{"kind":"Field","name":{"kind":"Name","value":"operator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isApplicationRelation"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"calls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageCallTimesBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageDetailsCallContainersBlockCall"}},{"kind":"Field","name":{"kind":"Name","value":"cargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageTimesheetCargoAction"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationWithGroup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageTankListCargo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageEditDialogCargo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentEntity"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageSummaryVoyage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Voyage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageProgressBarVoyage"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voyageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"inactivityType"}},{"kind":"Field","name":{"kind":"Name","value":"isBallast"}},{"kind":"Field","name":{"kind":"Name","value":"creditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactRelation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargoCharter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageProgressBarVoyage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Voyage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"to"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"calls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pta"}},{"kind":"Field","name":{"kind":"Name","value":"ptd"}},{"kind":"Field","name":{"kind":"Name","value":"ata"}},{"kind":"Field","name":{"kind":"Name","value":"atd"}},{"kind":"Field","name":{"kind":"Name","value":"eta"}},{"kind":"Field","name":{"kind":"Name","value":"etd"}},{"kind":"Field","name":{"kind":"Name","value":"simulatedTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"finishedStatus"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompactLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompactRelation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Relation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageCallListVoyage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Voyage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"isBallast"}},{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"to"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargoCharter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"calls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallTimes"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"expectedLoadingAmount"}},{"kind":"Field","name":{"kind":"Name","value":"expectedDischargingAmount"}},{"kind":"Field","name":{"kind":"Name","value":"expectedLoadingTeu"}},{"kind":"Field","name":{"kind":"Name","value":"expectedDischargingTeu"}},{"kind":"Field","name":{"kind":"Name","value":"nrLoadingCargos"}},{"kind":"Field","name":{"kind":"Name","value":"nrDischargingCargos"}},{"kind":"Field","name":{"kind":"Name","value":"callLoadingTeu"}},{"kind":"Field","name":{"kind":"Name","value":"callDischargingTeu"}},{"kind":"Field","name":{"kind":"Name","value":"simulatedTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageCargoActionListCargoAction"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallTimes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Call"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pta"}},{"kind":"Field","name":{"kind":"Name","value":"eta"}},{"kind":"Field","name":{"kind":"Name","value":"ata"}},{"kind":"Field","name":{"kind":"Name","value":"ptd"}},{"kind":"Field","name":{"kind":"Name","value":"etd"}},{"kind":"Field","name":{"kind":"Name","value":"atd"}},{"kind":"Field","name":{"kind":"Name","value":"etso"}},{"kind":"Field","name":{"kind":"Name","value":"eteo"}},{"kind":"Field","name":{"kind":"Name","value":"atso"}},{"kind":"Field","name":{"kind":"Name","value":"ateo"}},{"kind":"Field","name":{"kind":"Name","value":"etfm"}},{"kind":"Field","name":{"kind":"Name","value":"etlm"}},{"kind":"Field","name":{"kind":"Name","value":"atfm"}},{"kind":"Field","name":{"kind":"Name","value":"atlm"}},{"kind":"Field","name":{"kind":"Name","value":"atn"}},{"kind":"Field","name":{"kind":"Name","value":"dtn"}},{"kind":"Field","name":{"kind":"Name","value":"systemAta"}},{"kind":"Field","name":{"kind":"Name","value":"systemAtd"}},{"kind":"Field","name":{"kind":"Name","value":"systemEta"}},{"kind":"Field","name":{"kind":"Name","value":"systemEtd"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageCargoActionListCargoAction"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CargoAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"cargo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cargoNumber"}},{"kind":"Field","name":{"kind":"Name","value":"charter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageCargoActionDetailsVoyage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Voyage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastShippedProductsFreeText"}},{"kind":"Field","name":{"kind":"Name","value":"calls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pta"}},{"kind":"Field","name":{"kind":"Name","value":"cargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageCargoActionDetails"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageCargoActionDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CargoAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"simulatedTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"displayAsWindow"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"limitType"}},{"kind":"Field","name":{"kind":"Name","value":"limitValue"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"cargoActionActuals"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"uabRegistration"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"telephone"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"surveyor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactRelation"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"telephone"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipToShip"}},{"kind":"Field","name":{"kind":"Name","value":"connectingVisitNotes"}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipPortVisit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"until"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdateFromAgentOn"}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"planningNotes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactRelation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipBerthings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"window"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipBerthing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"window"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cargoNumber"}},{"kind":"Field","name":{"kind":"Name","value":"containerNumber"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"isWeightPrimary"}},{"kind":"Field","name":{"kind":"Name","value":"isVolumePrimary"}},{"kind":"Field","name":{"kind":"Name","value":"waterLevelOptimised"}},{"kind":"Field","name":{"kind":"Name","value":"weightToleranceType"}},{"kind":"Field","name":{"kind":"Name","value":"weightOptionType"}},{"kind":"Field","name":{"kind":"Name","value":"weightOptionPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"declaredFinalWeight"}},{"kind":"Field","name":{"kind":"Name","value":"isHoseRentalRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isInhibitedProduct"}},{"kind":"Field","name":{"kind":"Name","value":"isNitrogenBlanketingRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isNitrogenPurgingRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isTemperatureControlRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isCleaningRequired"}},{"kind":"Field","name":{"kind":"Name","value":"loadingReference"}},{"kind":"Field","name":{"kind":"Name","value":"dischargingReference"}},{"kind":"Field","name":{"kind":"Name","value":"customerTransportDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactRelation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consignor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactRelation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactRelation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"productInstructionsForVessel"}},{"kind":"Field","name":{"kind":"Name","value":"heatingInstructionsForVessel"}},{"kind":"Field","name":{"kind":"Name","value":"isDangerousGood"}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"cargoActionActuals"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CargoAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"measurements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationWeight"}},{"kind":"Field","name":{"kind":"Name","value":"locationWeightUnit"}},{"kind":"Field","name":{"kind":"Name","value":"skipperWeight"}},{"kind":"Field","name":{"kind":"Name","value":"skipperWeightUnit"}},{"kind":"Field","name":{"kind":"Name","value":"locationVolume"}},{"kind":"Field","name":{"kind":"Name","value":"locationVolumeUnit"}},{"kind":"Field","name":{"kind":"Name","value":"skipperVolume"}},{"kind":"Field","name":{"kind":"Name","value":"skipperVolumeUnit"}},{"kind":"Field","name":{"kind":"Name","value":"ambientVolume"}},{"kind":"Field","name":{"kind":"Name","value":"relativeDensity"}},{"kind":"Field","name":{"kind":"Name","value":"productTemperature"}},{"kind":"Field","name":{"kind":"Name","value":"actualConsignor"}},{"kind":"Field","name":{"kind":"Name","value":"actualConsignee"}},{"kind":"Field","name":{"kind":"Name","value":"protest"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageDocumentsVoyage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Voyage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voyageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"cargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cargoNumber"}},{"kind":"Field","name":{"kind":"Name","value":"containerNumber"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"calls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"displayCode"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageCallTimesBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Call"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallTimes"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"simulatedTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationWithGroup"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocationWithGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationGroup"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocationGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageDetailsCallContainersBlockCall"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Call"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallTimes"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"loadedWeight"}},{"kind":"Field","name":{"kind":"Name","value":"dischargedWeight"}},{"kind":"Field","name":{"kind":"Name","value":"expectedLoadingAmount"}},{"kind":"Field","name":{"kind":"Name","value":"expectedDischargingAmount"}},{"kind":"Field","name":{"kind":"Name","value":"expectedLoadingTeu"}},{"kind":"Field","name":{"kind":"Name","value":"expectedDischargingTeu"}},{"kind":"Field","name":{"kind":"Name","value":"nrLoadingCargos"}},{"kind":"Field","name":{"kind":"Name","value":"nrDischargingCargos"}},{"kind":"Field","name":{"kind":"Name","value":"callLoadingTeu"}},{"kind":"Field","name":{"kind":"Name","value":"callDischargingTeu"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expectedCargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actionType"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"full"}},{"kind":"Field","name":{"kind":"Name","value":"dischargingLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationWithGroup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"containerType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isoTypeCode"}},{"kind":"Field","name":{"kind":"Name","value":"teu"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageTimesheetCargoAction"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CargoAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"timesheetNote"}},{"kind":"Field","name":{"kind":"Name","value":"cargo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cargoNumber"}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageTimesheetStatus"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actualTime"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOriginal"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOverride"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageTimesheetStatus"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageTimesheetStatus"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"statusOrder"}},{"kind":"Field","name":{"kind":"Name","value":"cargoActionType"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeStartStatus"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeEndStatus"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageTankListCargo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Cargo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tanks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"tank"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"tank"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tank"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"positionNumber"}},{"kind":"Field","name":{"kind":"Name","value":"capacityM3"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageEditDialogCargo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Cargo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseCharter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customerReference"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyagePurchaseCharterTab"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Voyage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchaseCharters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"subtype"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageScopeTab"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Voyage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scopeIn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"desired"}},{"kind":"Field","name":{"kind":"Name","value":"planned"}},{"kind":"Field","name":{"kind":"Name","value":"actual"}},{"kind":"Field","name":{"kind":"Name","value":"systemActual"}},{"kind":"Field","name":{"kind":"Name","value":"expected"}},{"kind":"Field","name":{"kind":"Name","value":"systemExpected"}},{"kind":"Field","name":{"kind":"Name","value":"expectedLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"plannedLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"actualLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scopeOut"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"desired"}},{"kind":"Field","name":{"kind":"Name","value":"planned"}},{"kind":"Field","name":{"kind":"Name","value":"actual"}},{"kind":"Field","name":{"kind":"Name","value":"systemActual"}},{"kind":"Field","name":{"kind":"Name","value":"expected"}},{"kind":"Field","name":{"kind":"Name","value":"systemExpected"}},{"kind":"Field","name":{"kind":"Name","value":"expectedLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plannedLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actualLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<GetVoyageQuery, GetVoyageQueryVariables>;
export const VoyageDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"voyageDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voyage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageInfo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusChangeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StatusChange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actualTime"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOriginal"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOverride"}},{"kind":"Field","name":{"kind":"Name","value":"estimateTime"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"skipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"appliedBy"}},{"kind":"Field","name":{"kind":"Name","value":"deletable"}},{"kind":"Field","name":{"kind":"Name","value":"communicatedToCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cargoActionType"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"target"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusOrder"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ruleType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ifFitsStatusFlow"}},{"kind":"Field","name":{"kind":"Name","value":"ifNotAppliedBefore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInSailingReport"}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInWeightVolume"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"requireActualTime"}},{"kind":"Field","name":{"kind":"Name","value":"estimateType"}},{"kind":"Field","name":{"kind":"Name","value":"estimateRequirement"}},{"kind":"Field","name":{"kind":"Name","value":"shouldLoadOnTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"closedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledStatus"}},{"kind":"Field","name":{"kind":"Name","value":"loadedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dischargedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"finishedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"allowComment"}},{"kind":"Field","name":{"kind":"Name","value":"allowSkipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"shouldUpdateJDE"}},{"kind":"Field","name":{"kind":"Name","value":"isInProgress"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"callVisibleByLocationOwner"}},{"kind":"Field","name":{"kind":"Name","value":"isRejectStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isAcceptStatus"}},{"kind":"Field","name":{"kind":"Name","value":"notifySkippers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipManagers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipOwners"}},{"kind":"Field","name":{"kind":"Name","value":"notifyOperators"}},{"kind":"Field","name":{"kind":"Name","value":"notifyCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyTerminals"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomerNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isSkipperNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeInNominationExport"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeStartStatus"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeEndStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireDocuments"}},{"kind":"Field","name":{"kind":"Name","value":"showConfirmMessage"}},{"kind":"Field","name":{"kind":"Name","value":"expiringStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isActionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireTanks"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Voyage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageDetailsTab"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyagePurchaseCharterTab"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageScopeTab"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageDocumentsVoyage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageDetailsTab"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Voyage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageSummaryVoyage"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageCallListVoyage"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageCargoActionDetailsVoyage"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageDocumentsVoyage"}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bargeType"}},{"kind":"Field","name":{"kind":"Name","value":"operator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isApplicationRelation"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"calls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageCallTimesBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageDetailsCallContainersBlockCall"}},{"kind":"Field","name":{"kind":"Name","value":"cargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageTimesheetCargoAction"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationWithGroup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageTankListCargo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageEditDialogCargo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentEntity"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageSummaryVoyage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Voyage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageProgressBarVoyage"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voyageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"inactivityType"}},{"kind":"Field","name":{"kind":"Name","value":"isBallast"}},{"kind":"Field","name":{"kind":"Name","value":"creditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactRelation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargoCharter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageProgressBarVoyage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Voyage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"to"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"calls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pta"}},{"kind":"Field","name":{"kind":"Name","value":"ptd"}},{"kind":"Field","name":{"kind":"Name","value":"ata"}},{"kind":"Field","name":{"kind":"Name","value":"atd"}},{"kind":"Field","name":{"kind":"Name","value":"eta"}},{"kind":"Field","name":{"kind":"Name","value":"etd"}},{"kind":"Field","name":{"kind":"Name","value":"simulatedTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"finishedStatus"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompactLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompactRelation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Relation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageCallListVoyage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Voyage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"isBallast"}},{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"to"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargoCharter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"calls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallTimes"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"expectedLoadingAmount"}},{"kind":"Field","name":{"kind":"Name","value":"expectedDischargingAmount"}},{"kind":"Field","name":{"kind":"Name","value":"expectedLoadingTeu"}},{"kind":"Field","name":{"kind":"Name","value":"expectedDischargingTeu"}},{"kind":"Field","name":{"kind":"Name","value":"nrLoadingCargos"}},{"kind":"Field","name":{"kind":"Name","value":"nrDischargingCargos"}},{"kind":"Field","name":{"kind":"Name","value":"callLoadingTeu"}},{"kind":"Field","name":{"kind":"Name","value":"callDischargingTeu"}},{"kind":"Field","name":{"kind":"Name","value":"simulatedTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageCargoActionListCargoAction"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallTimes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Call"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pta"}},{"kind":"Field","name":{"kind":"Name","value":"eta"}},{"kind":"Field","name":{"kind":"Name","value":"ata"}},{"kind":"Field","name":{"kind":"Name","value":"ptd"}},{"kind":"Field","name":{"kind":"Name","value":"etd"}},{"kind":"Field","name":{"kind":"Name","value":"atd"}},{"kind":"Field","name":{"kind":"Name","value":"etso"}},{"kind":"Field","name":{"kind":"Name","value":"eteo"}},{"kind":"Field","name":{"kind":"Name","value":"atso"}},{"kind":"Field","name":{"kind":"Name","value":"ateo"}},{"kind":"Field","name":{"kind":"Name","value":"etfm"}},{"kind":"Field","name":{"kind":"Name","value":"etlm"}},{"kind":"Field","name":{"kind":"Name","value":"atfm"}},{"kind":"Field","name":{"kind":"Name","value":"atlm"}},{"kind":"Field","name":{"kind":"Name","value":"atn"}},{"kind":"Field","name":{"kind":"Name","value":"dtn"}},{"kind":"Field","name":{"kind":"Name","value":"systemAta"}},{"kind":"Field","name":{"kind":"Name","value":"systemAtd"}},{"kind":"Field","name":{"kind":"Name","value":"systemEta"}},{"kind":"Field","name":{"kind":"Name","value":"systemEtd"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageCargoActionListCargoAction"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CargoAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"cargo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cargoNumber"}},{"kind":"Field","name":{"kind":"Name","value":"charter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageCargoActionDetailsVoyage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Voyage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastShippedProductsFreeText"}},{"kind":"Field","name":{"kind":"Name","value":"calls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pta"}},{"kind":"Field","name":{"kind":"Name","value":"cargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageCargoActionDetails"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageCargoActionDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CargoAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"simulatedTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"displayAsWindow"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"limitType"}},{"kind":"Field","name":{"kind":"Name","value":"limitValue"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"cargoActionActuals"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"uabRegistration"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"telephone"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"surveyor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactRelation"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"telephone"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipToShip"}},{"kind":"Field","name":{"kind":"Name","value":"connectingVisitNotes"}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipPortVisit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"until"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdateFromAgentOn"}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"planningNotes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactRelation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipBerthings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"window"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipBerthing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"window"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cargoNumber"}},{"kind":"Field","name":{"kind":"Name","value":"containerNumber"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"isWeightPrimary"}},{"kind":"Field","name":{"kind":"Name","value":"isVolumePrimary"}},{"kind":"Field","name":{"kind":"Name","value":"waterLevelOptimised"}},{"kind":"Field","name":{"kind":"Name","value":"weightToleranceType"}},{"kind":"Field","name":{"kind":"Name","value":"weightOptionType"}},{"kind":"Field","name":{"kind":"Name","value":"weightOptionPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"declaredFinalWeight"}},{"kind":"Field","name":{"kind":"Name","value":"isHoseRentalRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isInhibitedProduct"}},{"kind":"Field","name":{"kind":"Name","value":"isNitrogenBlanketingRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isNitrogenPurgingRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isTemperatureControlRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isCleaningRequired"}},{"kind":"Field","name":{"kind":"Name","value":"loadingReference"}},{"kind":"Field","name":{"kind":"Name","value":"dischargingReference"}},{"kind":"Field","name":{"kind":"Name","value":"customerTransportDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactRelation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consignor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactRelation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactRelation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"productInstructionsForVessel"}},{"kind":"Field","name":{"kind":"Name","value":"heatingInstructionsForVessel"}},{"kind":"Field","name":{"kind":"Name","value":"isDangerousGood"}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"cargoActionActuals"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CargoAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"measurements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationWeight"}},{"kind":"Field","name":{"kind":"Name","value":"locationWeightUnit"}},{"kind":"Field","name":{"kind":"Name","value":"skipperWeight"}},{"kind":"Field","name":{"kind":"Name","value":"skipperWeightUnit"}},{"kind":"Field","name":{"kind":"Name","value":"locationVolume"}},{"kind":"Field","name":{"kind":"Name","value":"locationVolumeUnit"}},{"kind":"Field","name":{"kind":"Name","value":"skipperVolume"}},{"kind":"Field","name":{"kind":"Name","value":"skipperVolumeUnit"}},{"kind":"Field","name":{"kind":"Name","value":"ambientVolume"}},{"kind":"Field","name":{"kind":"Name","value":"relativeDensity"}},{"kind":"Field","name":{"kind":"Name","value":"productTemperature"}},{"kind":"Field","name":{"kind":"Name","value":"actualConsignor"}},{"kind":"Field","name":{"kind":"Name","value":"actualConsignee"}},{"kind":"Field","name":{"kind":"Name","value":"protest"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageDocumentsVoyage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Voyage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voyageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"cargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cargoNumber"}},{"kind":"Field","name":{"kind":"Name","value":"containerNumber"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"calls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"displayCode"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageCallTimesBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Call"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallTimes"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"simulatedTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationWithGroup"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocationWithGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationGroup"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocationGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageDetailsCallContainersBlockCall"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Call"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallTimes"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"loadedWeight"}},{"kind":"Field","name":{"kind":"Name","value":"dischargedWeight"}},{"kind":"Field","name":{"kind":"Name","value":"expectedLoadingAmount"}},{"kind":"Field","name":{"kind":"Name","value":"expectedDischargingAmount"}},{"kind":"Field","name":{"kind":"Name","value":"expectedLoadingTeu"}},{"kind":"Field","name":{"kind":"Name","value":"expectedDischargingTeu"}},{"kind":"Field","name":{"kind":"Name","value":"nrLoadingCargos"}},{"kind":"Field","name":{"kind":"Name","value":"nrDischargingCargos"}},{"kind":"Field","name":{"kind":"Name","value":"callLoadingTeu"}},{"kind":"Field","name":{"kind":"Name","value":"callDischargingTeu"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expectedCargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actionType"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"full"}},{"kind":"Field","name":{"kind":"Name","value":"dischargingLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationWithGroup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"containerType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isoTypeCode"}},{"kind":"Field","name":{"kind":"Name","value":"teu"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageTimesheetCargoAction"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CargoAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"timesheetNote"}},{"kind":"Field","name":{"kind":"Name","value":"cargo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cargoNumber"}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageTimesheetStatus"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actualTime"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOriginal"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOverride"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageTimesheetStatus"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageTimesheetStatus"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"statusOrder"}},{"kind":"Field","name":{"kind":"Name","value":"cargoActionType"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeStartStatus"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeEndStatus"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageTankListCargo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Cargo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tanks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"tank"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"tank"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tank"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"positionNumber"}},{"kind":"Field","name":{"kind":"Name","value":"capacityM3"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageEditDialogCargo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Cargo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseCharter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customerReference"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyagePurchaseCharterTab"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Voyage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchaseCharters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"subtype"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageScopeTab"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Voyage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scopeIn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"desired"}},{"kind":"Field","name":{"kind":"Name","value":"planned"}},{"kind":"Field","name":{"kind":"Name","value":"actual"}},{"kind":"Field","name":{"kind":"Name","value":"systemActual"}},{"kind":"Field","name":{"kind":"Name","value":"expected"}},{"kind":"Field","name":{"kind":"Name","value":"systemExpected"}},{"kind":"Field","name":{"kind":"Name","value":"expectedLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"plannedLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"actualLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scopeOut"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"desired"}},{"kind":"Field","name":{"kind":"Name","value":"planned"}},{"kind":"Field","name":{"kind":"Name","value":"actual"}},{"kind":"Field","name":{"kind":"Name","value":"systemActual"}},{"kind":"Field","name":{"kind":"Name","value":"expected"}},{"kind":"Field","name":{"kind":"Name","value":"systemExpected"}},{"kind":"Field","name":{"kind":"Name","value":"expectedLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plannedLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actualLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<VoyageDetailsQuery, VoyageDetailsQueryVariables>;
export const VoyageLogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"voyageLog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voyageLog"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GeneralVoyageLog"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GeneralVoyageLog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VoyageLog"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actualSailingDistanceInKm"}},{"kind":"Field","name":{"kind":"Name","value":"actualSailingMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"gasOilPrice"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSailingMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedSailingDistanceInKm"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedFuelConsumption"}},{"kind":"Field","name":{"kind":"Name","value":"actualFuelConsumption"}},{"kind":"Field","name":{"kind":"Name","value":"visitedPorts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enteredDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]} as unknown as DocumentNode<VoyageLogQuery, VoyageLogQueryVariables>;
export const GetVoyageCallsIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVoyageCallsId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voyage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetVoyageCallsIdQuery, GetVoyageCallsIdQueryVariables>;
export const GetVoyagePlanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVoyagePlan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voyagePlan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"warning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CallEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"pta"}},{"kind":"Field","name":{"kind":"Name","value":"ptd"}},{"kind":"Field","name":{"kind":"Name","value":"eta"}},{"kind":"Field","name":{"kind":"Name","value":"etd"}},{"kind":"Field","name":{"kind":"Name","value":"ata"}},{"kind":"Field","name":{"kind":"Name","value":"atd"}},{"kind":"Field","name":{"kind":"Name","value":"systemAta"}},{"kind":"Field","name":{"kind":"Name","value":"systemAtd"}},{"kind":"Field","name":{"kind":"Name","value":"systemEta"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"town"}}]}},{"kind":"Field","name":{"kind":"Name","value":"telephone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nrLoadingCargos"}},{"kind":"Field","name":{"kind":"Name","value":"nrDischargingCargos"}},{"kind":"Field","name":{"kind":"Name","value":"actualStatusCode"}},{"kind":"Field","name":{"kind":"Name","value":"loadingCargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"measurements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationVolumeL15"}},{"kind":"Field","name":{"kind":"Name","value":"locationWeightMTon"}},{"kind":"Field","name":{"kind":"Name","value":"skipperVolumeL15"}},{"kind":"Field","name":{"kind":"Name","value":"skipperVolumeM3"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"dischargingCargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"measurements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationVolumeL15"}},{"kind":"Field","name":{"kind":"Name","value":"locationWeightMTon"}},{"kind":"Field","name":{"kind":"Name","value":"skipperVolumeL15"}},{"kind":"Field","name":{"kind":"Name","value":"skipperVolumeM3"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"loadedWeight"}},{"kind":"Field","name":{"kind":"Name","value":"dischargedWeight"}},{"kind":"Field","name":{"kind":"Name","value":"loadedTeuOnVoyageAfterCall"}},{"kind":"Field","name":{"kind":"Name","value":"loadedWeightOnVoyageAfterCall"}},{"kind":"Field","name":{"kind":"Name","value":"remainingTeuCapacity"}},{"kind":"Field","name":{"kind":"Name","value":"remainingWeightCapacity"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfLoadingContainers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"numberOfContainersFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"numberOfDischargingContainers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"numberOfContainersFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"numberOfLoadingReeferContainers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"numberOfContainersFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"numberOfDischargingReeferContainers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"numberOfContainersFragment"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShippingEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distanceKm"}},{"kind":"Field","name":{"kind":"Name","value":"durationMin"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WaitingEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endTime"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BridgeEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"heightCm"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LockEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdate"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MeasuringPointEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"keelClearanceCm"}},{"kind":"Field","name":{"kind":"Name","value":"keelClearanceStatus"}},{"kind":"Field","name":{"kind":"Name","value":"measurement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"waterLevel"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"waterwayDepthCm"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"durationMin"}},{"kind":"Field","name":{"kind":"Name","value":"distanceKm"}},{"kind":"Field","name":{"kind":"Name","value":"lowestMeasuringPointDepth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"measurement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"waterLevel"}},{"kind":"Field","name":{"kind":"Name","value":"waterwayDepthCm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requiredWaterwayDepthCm"}},{"kind":"Field","name":{"kind":"Name","value":"keelClearanceStatus"}},{"kind":"Field","name":{"kind":"Name","value":"keelClearanceCm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lowestBridge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"heightCm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"totalWaitingTimeMin"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"numberOfContainersFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NumberOfContainers"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"numEmptyLessThanOrEqualTo20ft"}},{"kind":"Field","name":{"kind":"Name","value":"numEmptyFrom21ftThrough30ft"}},{"kind":"Field","name":{"kind":"Name","value":"numEmptyFrom31ftThrough40ft"}},{"kind":"Field","name":{"kind":"Name","value":"numEmptyGreaterThan40ft"}},{"kind":"Field","name":{"kind":"Name","value":"numFullLessThanOrEqualTo20ft"}},{"kind":"Field","name":{"kind":"Name","value":"numFullFrom21ftThrough30ft"}},{"kind":"Field","name":{"kind":"Name","value":"numFullFrom31ftThrough40ft"}},{"kind":"Field","name":{"kind":"Name","value":"numFullGreaterThan40ft"}},{"kind":"Field","name":{"kind":"Name","value":"numLessThanOrEqualTo20ft"}},{"kind":"Field","name":{"kind":"Name","value":"numFrom21ftThrough30ft"}},{"kind":"Field","name":{"kind":"Name","value":"numFrom31ftThrough40ft"}},{"kind":"Field","name":{"kind":"Name","value":"numGreaterThan40ft"}},{"kind":"Field","name":{"kind":"Name","value":"totalTeu"}},{"kind":"Field","name":{"kind":"Name","value":"numTotalFullContainers"}},{"kind":"Field","name":{"kind":"Name","value":"numTotalEmptyContainers"}},{"kind":"Field","name":{"kind":"Name","value":"numTotalContainers"}}]}}]} as unknown as DocumentNode<GetVoyagePlanQuery, GetVoyagePlanQueryVariables>;
export const GetVoyagePlanCompactDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVoyagePlanCompact"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voyagePlan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"durationMin"}},{"kind":"Field","name":{"kind":"Name","value":"distanceKm"}},{"kind":"Field","name":{"kind":"Name","value":"totalWaitingTimeMin"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"lowestMeasuringPointDepth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"keelClearanceCm"}},{"kind":"Field","name":{"kind":"Name","value":"measurement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"waterLevel"}},{"kind":"Field","name":{"kind":"Name","value":"waterwayDepthCm"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetVoyagePlanCompactQuery, GetVoyagePlanCompactQueryVariables>;
export const GetReeferChecklistDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReeferChecklist"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"voyageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voyage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"voyageId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"loaded"}},{"kind":"Field","name":{"kind":"Name","value":"loadingReference"}},{"kind":"Field","name":{"kind":"Name","value":"desiredTemperature"}},{"kind":"Field","name":{"kind":"Name","value":"containerNumber"}},{"kind":"Field","name":{"kind":"Name","value":"containerType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isoTypeCode"}},{"kind":"Field","name":{"kind":"Name","value":"displayCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstLoadingAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"displayCode"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastDischargingAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"displayCode"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reeferCheckType"}},{"kind":"Field","name":{"kind":"Name","value":"reeferChecklist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"setPoint"}},{"kind":"Field","name":{"kind":"Name","value":"plugin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"temperature"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plugout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"temperature"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetReeferChecklistQuery, GetReeferChecklistQueryVariables>;
export const GetVoyageReorderCallsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVoyageReorderCalls"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"voyageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voyage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"voyageId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"callReorder"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusChangeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StatusChange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actualTime"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOriginal"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOverride"}},{"kind":"Field","name":{"kind":"Name","value":"estimateTime"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"skipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"appliedBy"}},{"kind":"Field","name":{"kind":"Name","value":"deletable"}},{"kind":"Field","name":{"kind":"Name","value":"communicatedToCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cargoActionType"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"target"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusOrder"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ruleType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ifFitsStatusFlow"}},{"kind":"Field","name":{"kind":"Name","value":"ifNotAppliedBefore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInSailingReport"}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInWeightVolume"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"requireActualTime"}},{"kind":"Field","name":{"kind":"Name","value":"estimateType"}},{"kind":"Field","name":{"kind":"Name","value":"estimateRequirement"}},{"kind":"Field","name":{"kind":"Name","value":"shouldLoadOnTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"closedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledStatus"}},{"kind":"Field","name":{"kind":"Name","value":"loadedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dischargedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"finishedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"allowComment"}},{"kind":"Field","name":{"kind":"Name","value":"allowSkipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"shouldUpdateJDE"}},{"kind":"Field","name":{"kind":"Name","value":"isInProgress"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"callVisibleByLocationOwner"}},{"kind":"Field","name":{"kind":"Name","value":"isRejectStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isAcceptStatus"}},{"kind":"Field","name":{"kind":"Name","value":"notifySkippers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipManagers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipOwners"}},{"kind":"Field","name":{"kind":"Name","value":"notifyOperators"}},{"kind":"Field","name":{"kind":"Name","value":"notifyCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyTerminals"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomerNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isSkipperNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeInNominationExport"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeStartStatus"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeEndStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireDocuments"}},{"kind":"Field","name":{"kind":"Name","value":"showConfirmMessage"}},{"kind":"Field","name":{"kind":"Name","value":"expiringStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isActionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireTanks"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompactLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"callReorder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Call"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pta"}},{"kind":"Field","name":{"kind":"Name","value":"simulatedTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"simulatedTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"cargo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cargoNumber"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"simulatedTimestamp"}}]}}]}}]} as unknown as DocumentNode<GetVoyageReorderCallsQuery, GetVoyageReorderCallsQueryVariables>;
export const GetVoyageTimesheetStatusesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVoyageTimesheetStatuses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StatusSearch"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageTimesheetStatus"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"cargoActionType"}},{"kind":"Field","name":{"kind":"Name","value":"statusOrder"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeStartStatus"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeEndStatus"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageTimesheetStatus"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"statusOrder"}},{"kind":"Field","name":{"kind":"Name","value":"cargoActionType"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeStartStatus"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeEndStatus"}}]}}]} as unknown as DocumentNode<GetVoyageTimesheetStatusesQuery, GetVoyageTimesheetStatusesQueryVariables>;
export const GetAssignableShipTanksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssignableShipTanks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"voyageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cargoId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shipId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ship"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shipId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"shipTanks"}},{"kind":"Field","name":{"kind":"Name","value":"tanks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isAssignable"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"voyageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"voyageId"}}},{"kind":"Argument","name":{"kind":"Name","value":"cargoId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cargoId"}}}]}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"shipTanks"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Ship"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tankProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tankConfiguration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tanks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"positionNumber"}},{"kind":"Field","name":{"kind":"Name","value":"capacityM3"}}]}}]}}]} as unknown as DocumentNode<GetAssignableShipTanksQuery, GetAssignableShipTanksQueryVariables>;
export const GetActiveVoyageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetActiveVoyage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shipId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activeVoyage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"shipId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shipId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageInfo"}},{"kind":"Field","name":{"kind":"Name","value":"sailingReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusChangeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StatusChange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actualTime"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOriginal"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOverride"}},{"kind":"Field","name":{"kind":"Name","value":"estimateTime"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"skipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"appliedBy"}},{"kind":"Field","name":{"kind":"Name","value":"deletable"}},{"kind":"Field","name":{"kind":"Name","value":"communicatedToCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cargoActionType"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"target"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusOrder"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ruleType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ifFitsStatusFlow"}},{"kind":"Field","name":{"kind":"Name","value":"ifNotAppliedBefore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInSailingReport"}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInWeightVolume"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"requireActualTime"}},{"kind":"Field","name":{"kind":"Name","value":"estimateType"}},{"kind":"Field","name":{"kind":"Name","value":"estimateRequirement"}},{"kind":"Field","name":{"kind":"Name","value":"shouldLoadOnTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"closedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledStatus"}},{"kind":"Field","name":{"kind":"Name","value":"loadedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dischargedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"finishedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"allowComment"}},{"kind":"Field","name":{"kind":"Name","value":"allowSkipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"shouldUpdateJDE"}},{"kind":"Field","name":{"kind":"Name","value":"isInProgress"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"callVisibleByLocationOwner"}},{"kind":"Field","name":{"kind":"Name","value":"isRejectStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isAcceptStatus"}},{"kind":"Field","name":{"kind":"Name","value":"notifySkippers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipManagers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipOwners"}},{"kind":"Field","name":{"kind":"Name","value":"notifyOperators"}},{"kind":"Field","name":{"kind":"Name","value":"notifyCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyTerminals"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomerNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isSkipperNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeInNominationExport"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeStartStatus"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeEndStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireDocuments"}},{"kind":"Field","name":{"kind":"Name","value":"showConfirmMessage"}},{"kind":"Field","name":{"kind":"Name","value":"expiringStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isActionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireTanks"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Voyage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageDetailsTab"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyagePurchaseCharterTab"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageScopeTab"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageDocumentsVoyage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageDetailsTab"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Voyage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageSummaryVoyage"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageCallListVoyage"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageCargoActionDetailsVoyage"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageDocumentsVoyage"}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bargeType"}},{"kind":"Field","name":{"kind":"Name","value":"operator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isApplicationRelation"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"calls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageCallTimesBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageDetailsCallContainersBlockCall"}},{"kind":"Field","name":{"kind":"Name","value":"cargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageTimesheetCargoAction"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationWithGroup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageTankListCargo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageEditDialogCargo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentEntity"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageSummaryVoyage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Voyage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageProgressBarVoyage"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voyageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"inactivityType"}},{"kind":"Field","name":{"kind":"Name","value":"isBallast"}},{"kind":"Field","name":{"kind":"Name","value":"creditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactRelation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargoCharter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageProgressBarVoyage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Voyage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"to"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"calls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pta"}},{"kind":"Field","name":{"kind":"Name","value":"ptd"}},{"kind":"Field","name":{"kind":"Name","value":"ata"}},{"kind":"Field","name":{"kind":"Name","value":"atd"}},{"kind":"Field","name":{"kind":"Name","value":"eta"}},{"kind":"Field","name":{"kind":"Name","value":"etd"}},{"kind":"Field","name":{"kind":"Name","value":"simulatedTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"finishedStatus"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompactLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompactRelation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Relation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageCallListVoyage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Voyage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"isBallast"}},{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"to"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargoCharter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"calls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallTimes"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"expectedLoadingAmount"}},{"kind":"Field","name":{"kind":"Name","value":"expectedDischargingAmount"}},{"kind":"Field","name":{"kind":"Name","value":"expectedLoadingTeu"}},{"kind":"Field","name":{"kind":"Name","value":"expectedDischargingTeu"}},{"kind":"Field","name":{"kind":"Name","value":"nrLoadingCargos"}},{"kind":"Field","name":{"kind":"Name","value":"nrDischargingCargos"}},{"kind":"Field","name":{"kind":"Name","value":"callLoadingTeu"}},{"kind":"Field","name":{"kind":"Name","value":"callDischargingTeu"}},{"kind":"Field","name":{"kind":"Name","value":"simulatedTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageCargoActionListCargoAction"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallTimes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Call"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pta"}},{"kind":"Field","name":{"kind":"Name","value":"eta"}},{"kind":"Field","name":{"kind":"Name","value":"ata"}},{"kind":"Field","name":{"kind":"Name","value":"ptd"}},{"kind":"Field","name":{"kind":"Name","value":"etd"}},{"kind":"Field","name":{"kind":"Name","value":"atd"}},{"kind":"Field","name":{"kind":"Name","value":"etso"}},{"kind":"Field","name":{"kind":"Name","value":"eteo"}},{"kind":"Field","name":{"kind":"Name","value":"atso"}},{"kind":"Field","name":{"kind":"Name","value":"ateo"}},{"kind":"Field","name":{"kind":"Name","value":"etfm"}},{"kind":"Field","name":{"kind":"Name","value":"etlm"}},{"kind":"Field","name":{"kind":"Name","value":"atfm"}},{"kind":"Field","name":{"kind":"Name","value":"atlm"}},{"kind":"Field","name":{"kind":"Name","value":"atn"}},{"kind":"Field","name":{"kind":"Name","value":"dtn"}},{"kind":"Field","name":{"kind":"Name","value":"systemAta"}},{"kind":"Field","name":{"kind":"Name","value":"systemAtd"}},{"kind":"Field","name":{"kind":"Name","value":"systemEta"}},{"kind":"Field","name":{"kind":"Name","value":"systemEtd"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageCargoActionListCargoAction"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CargoAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"cargo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cargoNumber"}},{"kind":"Field","name":{"kind":"Name","value":"charter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageCargoActionDetailsVoyage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Voyage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastShippedProductsFreeText"}},{"kind":"Field","name":{"kind":"Name","value":"calls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pta"}},{"kind":"Field","name":{"kind":"Name","value":"cargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageCargoActionDetails"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageCargoActionDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CargoAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"simulatedTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"displayAsWindow"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"limitType"}},{"kind":"Field","name":{"kind":"Name","value":"limitValue"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"cargoActionActuals"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"uabRegistration"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"telephone"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"surveyor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactRelation"}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"telephone"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipToShip"}},{"kind":"Field","name":{"kind":"Name","value":"connectingVisitNotes"}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipPortVisit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"until"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdateFromAgentOn"}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"planningNotes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactRelation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipBerthings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"window"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipBerthing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"window"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cargoNumber"}},{"kind":"Field","name":{"kind":"Name","value":"containerNumber"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"isWeightPrimary"}},{"kind":"Field","name":{"kind":"Name","value":"isVolumePrimary"}},{"kind":"Field","name":{"kind":"Name","value":"waterLevelOptimised"}},{"kind":"Field","name":{"kind":"Name","value":"weightToleranceType"}},{"kind":"Field","name":{"kind":"Name","value":"weightOptionType"}},{"kind":"Field","name":{"kind":"Name","value":"weightOptionPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"declaredFinalWeight"}},{"kind":"Field","name":{"kind":"Name","value":"isHoseRentalRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isInhibitedProduct"}},{"kind":"Field","name":{"kind":"Name","value":"isNitrogenBlanketingRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isNitrogenPurgingRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isTemperatureControlRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isCleaningRequired"}},{"kind":"Field","name":{"kind":"Name","value":"loadingReference"}},{"kind":"Field","name":{"kind":"Name","value":"dischargingReference"}},{"kind":"Field","name":{"kind":"Name","value":"customerTransportDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactRelation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consignor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactRelation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactRelation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"productInstructionsForVessel"}},{"kind":"Field","name":{"kind":"Name","value":"heatingInstructionsForVessel"}},{"kind":"Field","name":{"kind":"Name","value":"isDangerousGood"}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"cargoActionActuals"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CargoAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"measurements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationWeight"}},{"kind":"Field","name":{"kind":"Name","value":"locationWeightUnit"}},{"kind":"Field","name":{"kind":"Name","value":"skipperWeight"}},{"kind":"Field","name":{"kind":"Name","value":"skipperWeightUnit"}},{"kind":"Field","name":{"kind":"Name","value":"locationVolume"}},{"kind":"Field","name":{"kind":"Name","value":"locationVolumeUnit"}},{"kind":"Field","name":{"kind":"Name","value":"skipperVolume"}},{"kind":"Field","name":{"kind":"Name","value":"skipperVolumeUnit"}},{"kind":"Field","name":{"kind":"Name","value":"ambientVolume"}},{"kind":"Field","name":{"kind":"Name","value":"relativeDensity"}},{"kind":"Field","name":{"kind":"Name","value":"productTemperature"}},{"kind":"Field","name":{"kind":"Name","value":"actualConsignor"}},{"kind":"Field","name":{"kind":"Name","value":"actualConsignee"}},{"kind":"Field","name":{"kind":"Name","value":"protest"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageDocumentsVoyage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Voyage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voyageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"cargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cargoNumber"}},{"kind":"Field","name":{"kind":"Name","value":"containerNumber"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"calls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"displayCode"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageCallTimesBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Call"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallTimes"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"simulatedTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationWithGroup"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocationWithGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationGroup"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocationGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageDetailsCallContainersBlockCall"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Call"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallTimes"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"loadedWeight"}},{"kind":"Field","name":{"kind":"Name","value":"dischargedWeight"}},{"kind":"Field","name":{"kind":"Name","value":"expectedLoadingAmount"}},{"kind":"Field","name":{"kind":"Name","value":"expectedDischargingAmount"}},{"kind":"Field","name":{"kind":"Name","value":"expectedLoadingTeu"}},{"kind":"Field","name":{"kind":"Name","value":"expectedDischargingTeu"}},{"kind":"Field","name":{"kind":"Name","value":"nrLoadingCargos"}},{"kind":"Field","name":{"kind":"Name","value":"nrDischargingCargos"}},{"kind":"Field","name":{"kind":"Name","value":"callLoadingTeu"}},{"kind":"Field","name":{"kind":"Name","value":"callDischargingTeu"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expectedCargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actionType"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"full"}},{"kind":"Field","name":{"kind":"Name","value":"dischargingLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationWithGroup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"containerType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isoTypeCode"}},{"kind":"Field","name":{"kind":"Name","value":"teu"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageTimesheetCargoAction"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CargoAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"timesheetNote"}},{"kind":"Field","name":{"kind":"Name","value":"cargo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cargoNumber"}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageTimesheetStatus"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actualTime"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOriginal"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOverride"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageTimesheetStatus"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageTimesheetStatus"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"statusOrder"}},{"kind":"Field","name":{"kind":"Name","value":"cargoActionType"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeStartStatus"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeEndStatus"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageTankListCargo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Cargo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tanks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"tank"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"tank"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tank"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"positionNumber"}},{"kind":"Field","name":{"kind":"Name","value":"capacityM3"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageEditDialogCargo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Cargo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseCharter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customerReference"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyagePurchaseCharterTab"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Voyage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchaseCharters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"subtype"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageScopeTab"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Voyage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scopeIn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"desired"}},{"kind":"Field","name":{"kind":"Name","value":"planned"}},{"kind":"Field","name":{"kind":"Name","value":"actual"}},{"kind":"Field","name":{"kind":"Name","value":"systemActual"}},{"kind":"Field","name":{"kind":"Name","value":"expected"}},{"kind":"Field","name":{"kind":"Name","value":"systemExpected"}},{"kind":"Field","name":{"kind":"Name","value":"expectedLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"plannedLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"actualLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scopeOut"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"desired"}},{"kind":"Field","name":{"kind":"Name","value":"planned"}},{"kind":"Field","name":{"kind":"Name","value":"actual"}},{"kind":"Field","name":{"kind":"Name","value":"systemActual"}},{"kind":"Field","name":{"kind":"Name","value":"expected"}},{"kind":"Field","name":{"kind":"Name","value":"systemExpected"}},{"kind":"Field","name":{"kind":"Name","value":"expectedLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plannedLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actualLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<GetActiveVoyageQuery, GetActiveVoyageQueryVariables>;